<div class="plans-bg" *ngIf="!quotationIsExpired">
  <!-- For Announcement description -->
  <mat-card class="announcement-card" *ngIf="announcementExist">
    <mat-icon class="close-btn" (click)="closeAnnouncement()">
      close_small
    </mat-icon>
    <div class="border-card__flex border-card__announcement">
      <div class="announcementcontainer">
        <div class="border-card__main announcement-title">
          <span
            class="announcement-description"
            [innerHTML]="formatAnnouncement(announceText)"
            >{{ announceText }}</span
          >
        </div>
      </div>
    </div>
  </mat-card>
  <!-- For Announcement description -->

  <mat-stepper
    linear
    labelPosition="bottom"
    #stepper
    (selectionChange)="onStepChange($event)"
    [ngClass]="hideStepperLabel"
  >
    <!-- ## Step: First step -->
    <mat-step [stepControl]="quotationFormGroup">
      <form [formGroup]="quotationFormGroup">
        <ng-container *ngIf="ctaBanner.length != 0">
          <div *ngFor="let banner of ctaBanner" class="cta-banner constraint">
            <img
              [src]="banner.src"
              [alt]="banner.alt"
              *ngIf="translate.currentLang == banner.lang && banner.show"
            />
          </div>
        </ng-container>
        <mat-card class="border-card">
          <div class="border-card__flex">
            <div class="border-card__container">
              <div class="border-card__main-title">
                <img
                  src="https://storage.googleapis.com/dev-ps-asset/Car_Insurance/icons/car-icon.png"
                  alt=""
                />
                {{ "common.carDetails" | translate }}
              </div>
              <div class="border-card__content-wrapper">
                <div class="border-card__label-container">
                  <div class="label-desc">
                    {{ "common.carNumber" | translate }} :
                  </div>
                  <div class="label-value">
                    {{ personalInfo?.vehicleNo }}
                  </div>
                </div>
                <div class="border-card__label-container">
                  <div class="label-desc">
                    {{ "common.carModel" | translate }} :
                  </div>
                  <div class="label-value">
                    {{ personalInfo?.vehicle }}
                  </div>
                </div>
              </div>
            </div>

            <div class="border-card__container">
              <div class="border-card__main-title">
                <img
                  src="https://storage.googleapis.com/dev-ps-asset/Car_Insurance/icons/shield-icon.png"
                  alt=""
                />
                {{ "common.carProtectionPlan" | translate }}
              </div>
              <div class="border-card__content-wrapper">
                <div class="border-card__label-container">
                  <div class="label-desc">
                    {{ "common.typeOfInsuranceTakaful" | translate }}
                    :
                  </div>
                  <div class="label-value">
                    {{ "common." + personalInfo?.insuranceType | translate }}
                  </div>
                </div>
                <div class="border-card__label-container">
                  <div class="label-desc">
                    {{ "common.effectiveDate" | translate }} :
                  </div>
                  <div class="label-value">
                    {{ personalInfo?.effectiveDate | date : "dd MMM yyyy" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            mat-stroked-button
            (click)="editQuotation()"
            class="stroked-btn"
            [matTooltip]="'common.editQuotationDisabledTooltip' | translate"
            [matTooltipDisabled]="!disableEditQuotationBtn"
            [disabled]="disableEditQuotationBtn"
          >
            {{ "common.editQuotation" | translate }}
          </button>
        </mat-card>
        <div
          style="display: flex; justify-content: center; padding-bottom: 18px"
        >
          <div
            style="
              display: inline-flex;
              align-items: center;
              gap: 8px;
              background-color: #e8f5e9;
              border-radius: 10px;
              padding: 12px 20px;
              font-family: sans-serif;
              font-size: 14px;
              color: #2e7d32;
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#2e7d32"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
              <polyline points="9 16 11 18 15 14" />
            </svg>
            <span
              ><strong
                >{{ "common.validQuotation" | translate }}
                {{ expiredMotorLink | date : "dd MMM yyyy" }}</strong
              ></span
            >
          </div>
        </div>
        <div class="comparison-section-title">
          <app-section-title
            title="comparison.quotationAvalTxt"
            desc="comparison.quotationAvalDesc"
          >
          </app-section-title>
        </div>
        <div *ngFor="let item of quotationList; let first = first">
          <!--Other insurers card -->
          <app-insurer-card-v2
            [first]="first"
            [item]="item"
            [ehailingUsed]="isEHailing"
            (onSubmit)="openCarVariantDialog(item?.id)"
            *ngIf="item?.status == 'Available' && personalInfo"
            [insuranceType]="personalInfo.insuranceType"
            [isEV]="isEV"
          >
          </app-insurer-card-v2>
        </div>
        <ng-container *ngFor="let item of sortedQuotationList">
          <app-loading-insurer-card
            [insurer]="item"
            *ngIf="item?.status == 'New' || item?.status == 'Rejected'"
          ></app-loading-insurer-card>
        </ng-container>
        <div class="other-insurer-section">
          <app-section-title
            title="plans.step1Content.exploreOther"
            desc="plans.step1Content.exploreOtherDesc"
          ></app-section-title>
          <div class="other-insurer-section__cards">
            <app-other-insurer-card
              (clickEvent)="updateSelectedInsurers($event)"
              *ngFor="let x of otherInsurerList"
              [insurer]="x"
            ></app-other-insurer-card>
          </div>
          <button
            mat-stroked-button
            class="stroked-btn mv-lg"
            (click)="submitOtherInsurer()"
          >
            {{ "comparison.getQuoteNow" | translate }}
          </button>
        </div>
      </form>
      <div class="floating-icon" *ngIf="displayExitIntentIcon">
        <div class="help-bubble" *ngIf="displayHelpBubble">Having Trouble?</div>
        <button (click)="displayExitInternDialog()">
          <img
            src="https://storage.googleapis.com/ps-asset/motor/comparison_page/Icon_Exit.svg"
          />
        </button>
      </div>
    </mat-step>

    <!-- ## Step: Second step -->
    <mat-step state="edit" [stepControl]="addOnFormGroup">
      <ng-template matStepLabel>
        {{ "plans.step1" | translate }}
      </ng-template>
      <button mat-button matStepperPrevious class="step-back-btn">
        <mat-icon>arrow_back</mat-icon> {{ "common.back" | translate }}
      </button>

      <form [formGroup]="addOnFormGroup">
        <div class="plans-container">
          <div class="main-container">
            <!-- Campaign Banner with Timer -->
            <div
              class="mt-md"
              *ngIf="!(screenSizeService.isMobile$ | async) && cdTimerShow"
            >
              <div class="ph-sm">
                <div class="campaign-banner">
                  <div class="ribbon-container">
                    <img
                      class="ribbon-img"
                      src="/assets/image/red-ribbon-left.svg"
                    />
                    <div class="save-badge">
                      <img
                        class="badge-img"
                        src="/assets/image/campaignBadge.gif"
                      />
                    </div>
                  </div>
                  <div class="campaign-content">
                    <div class="campaign-text">
                      <div>
                        <span
                          class="header"
                          [innerHTML]="'common.EnjoyTenOffHeader' | translate"
                        ></span>
                      </div>

                      <div>
                        <span
                          class="body"
                          [innerHTML]="'common.EnjoyTenOffBody' | translate"
                        ></span>
                      </div>
                    </div>
                  </div>

                  <div class="campaign-timer-box">
                    <span class="campaign-timer-title">{{
                      cdTimerStartEndLabel | translate
                    }}</span>
                    <div class="campaign-timer">
                      <div>
                        <span>{{ cdTimerHours | number : "2.0" }}</span>
                        <label>hrs</label>
                      </div>
                      <div class="campaign-timer-colon">:</div>
                      <div>
                        <span>{{ cdTimerMinutes | number : "2.0" }}</span>
                        <label>min</label>
                      </div>
                      <div class="campaign-timer-colon">:</div>
                      <div>
                        <span>{{ cdTimerSeconds | number : "2.0" }}</span>
                        <label>sec</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Campaign Free Road Tax Banner -->
            <div class="mt-md" *ngIf="campaignBannerEnabled">
              <img
                [src]="
                  'https://storage.googleapis.com/ps-asset/motor/d2c/campaignBanner/FreeRoadTaxBanner-' +
                  translate.currentLang +
                  '.svg'
                "
                style="width: 100%"
              />
            </div>

            <!-- MTR-578: TEMPORARILY HIDE FFF BUNDLE -->
            <div class="bundle-container" style="display: none">
              <app-section-title
                title="plans.step1Content.bundleSecTitle"
                desc="plans.step1Content.bundleSecDesc"
              ></app-section-title>
              <mat-chip-list>
                <mat-chip
                  [selected]="
                    floodChip.selected || floodAddonChip.selected || true
                  "
                  #floodChip="matChip"
                  (click)="floodChip.selected = true"
                  >{{ "plans.step1Content.floodChip" | translate }}</mat-chip
                >
                <mat-chip
                  #femaleChip="matChip"
                  [selected]="femaleChip.selected || femaleAddonChip.selected"
                  (click)="femaleChip.selected = true"
                  >{{ "plans.step1Content.femaleChip" | translate }}</mat-chip
                >
                <mat-chip
                  #familyChip="matChip"
                  [selected]="familyChip.selected || familyAddonChip.selected"
                  (click)="familyChip.selected = true"
                  >{{ "plans.step1Content.familyChip" | translate }}</mat-chip
                >
              </mat-chip-list>
              <ng-container *ngFor="let item of data?.motorBundle">
                <ng-container
                  *ngIf="
                    (floodAddonChip.selected || floodChip.selected) &&
                    item.code == 'Flood'
                  "
                >
                  <app-bundle-card
                    (addBundle)="addBundle(item)"
                    (removeBundle)="removeBundle(item)"
                    [item]="item"
                    [selectedBundle]="selectedBundle"
                    [expandedData]="floodBenefitsSnippets"
                    [sumInsured]="selectedQuotation?.sumInsured"
                    [coverageLink]="getBundleBrochure(item.code)"
                    [recommended]="true"
                  ></app-bundle-card>
                </ng-container>
                <ng-container
                  *ngIf="femaleChip.selected && item.code == 'Female'"
                >
                  <app-bundle-card
                    (addBundle)="addBundle(item)"
                    (removeBundle)="removeBundle(item)"
                    [item]="item"
                    [selectedBundle]="selectedBundle"
                    [expandedData]="femaleBenefitsSnippets"
                    [coverageLink]="getBundleBrochure(item.code)"
                    [recommended]="false"
                  ></app-bundle-card>
                </ng-container>
                <ng-container
                  *ngIf="familyChip.selected && item.code == 'Family'"
                >
                  <app-bundle-card
                    (addBundle)="addBundle(item)"
                    (removeBundle)="removeBundle(item)"
                    [item]="item"
                    [selectedBundle]="selectedBundle"
                    [expandedData]="familyBenefitsSnippets"
                    [coverageLink]="getBundleBrochure(item.code)"
                    [recommended]="false"
                  ></app-bundle-card>
                </ng-container>
              </ng-container>
            </div>
            <div class="pt-xs">
              <div class="ph-sm">
                <app-section-title
                  title="plans.step1Content.addOnsTitle"
                  desc="{{
                    isTakaful
                      ? 'plans.step1Content.addOnsDescTakaful'
                      : 'plans.step1Content.addOnsDescInsurance'
                  }}"
                ></app-section-title>

                <ng-container *ngIf="motorMembershipList && !isEHailing">
                  <div
                    class="drivePlus lite"
                    [ngClass]="{
                      lite: selectedMotorMembershipString === 'DrivePlusLite',
                      standard:
                        selectedMotorMembershipString === 'DrivePlusStandard',
                      premium:
                        selectedMotorMembershipString === 'DrivePlusPremium'
                    }"
                  >
                    <img
                      [src]="
                        '/assets/image/exclusive-in-ps-' +
                        translate.currentLang +
                        '.svg'
                      "
                      alt=""
                      class="drivePlus__tag"
                      *ngIf="
                        getMotorMembershipClass(motorMembershipList[0]) ===
                        'motorMembership'
                      "
                    />
                    <img
                      [src]="
                        'https://storage.googleapis.com/dev-ps-asset/motor/d2c/loyalty-programme-tag-' +
                        translate.currentLang +
                        '.png'
                      "
                      alt=""
                      *ngIf="
                        getMotorMembershipClass(motorMembershipList[0]) ===
                        'motorMembershipLoyalty'
                      "
                      class="drivePlus__tag loyalty"
                    />
                    <img
                      [src]="
                        'https://storage.googleapis.com/dev-ps-asset/motor/d2c/special-promo-tag-tmim-' +
                        translate.currentLang +
                        '.png'
                      "
                      alt=""
                      *ngIf="
                        getMotorMembershipClass(motorMembershipList[0]) ===
                        'motorMembershipTMIM'
                      "
                      class="drivePlus__tag tmim"
                    />
                    <div class="drivePlus__card">
                      <div class="drivePlus__card__flex">
                        <img
                          src="/assets/image/drive-plus-membership.png"
                          alt=""
                          class="drivePlus__img"
                        />
                        <div>
                          <div class="title">
                            <div>
                              {{
                                "plans.motorMembership.DrivePlus" | translate
                              }}
                            </div>
                            <mat-checkbox
                              class="drivePlus__checkbox"
                              [checked]="drivePlusTierChecked"
                              (change)="
                                toggleMotorMembership(
                                  $event,
                                  defaultMotorMembership,
                                  false
                                )
                              "
                            ></mat-checkbox>
                          </div>
                          <div>
                            {{
                              "plans.motorMembership.DrivePlusDesc" | translate
                            }}
                          </div>
                          <div *ngIf="!(screenSizeService.isMobile$ | async)">
                            <ng-container *ngIf="!drivePlusTierChecked">
                              <div class="drivePlus__card__special mt-sm">
                                <span class="small">RM</span>
                                {{ drivePlusLiteAddon?.evaluate }}
                                {{
                                  "plans.motorMembership.PromoPrice" | translate
                                }}
                              </div>

                              <div>
                                {{ "plans.motorMembership.NP" | translate }}:
                                RM{{ drivePlusLiteAddon?.oriEvaluate }}
                              </div>
                            </ng-container>
                            <ng-container
                              *ngTemplateOutlet="drivePlusTemplate"
                            ></ng-container>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="screenSizeService.isMobile$ | async">
                        <ng-container
                          *ngTemplateOutlet="drivePlusTemplate"
                        ></ng-container>
                        <ng-container *ngIf="!drivePlusTierChecked">
                          <div class="drivePlus__card__special mt-sm">
                            <span class="small">RM</span>
                            {{ drivePlusLiteAddon?.evaluate }}
                            {{ "plans.motorMembership.PromoPrice" | translate }}
                          </div>

                          <div>
                            {{ "plans.motorMembership.NP" | translate }}: RM{{
                              drivePlusLiteAddon?.oriEvaluate
                            }}
                          </div>
                        </ng-container>
                      </div>
                      <br />
                      <div
                        class="drivePlus__card__flex2"
                        *ngIf="selectedMotorMembership.length"
                      >
                        <div class="drivePlus__card__roadtax">
                          <img
                            src="/assets/image/driveplus-roadtax.png"
                            alt=""
                          />
                          <div class="pt-sm">
                            <span
                              class="bold"
                              [innerHTML]="
                                'plans.motorMembership.RoadtaxCard1'
                                  | translate
                                    : {
                                        discountPercentage:
                                          roadTaxDiscountMembership.discountPercentage,
                                        maxCapAmount:
                                          roadTaxDiscountMembership.maxCapAmount
                                      }
                              "
                            >
                            </span>
                            <br />
                          </div>
                          <div class="drivePlus__card__roadtax__specialPrice">
                            <span class="strikethrough"
                              >RM {{ personalInfo.originalRoadTaxPrice }}</span
                            >
                            <span class="specialPrice"
                              >RM {{ roadTaxDiscountMembership.evaluate }}
                              <span class="">
                                {{ "plans.motorMembership.Only" | translate }}
                              </span></span
                            >
                          </div>
                        </div>
                        <div>
                          <div>
                            {{
                              "plans.motorMembership.OtherBenefits" | translate
                            }}
                          </div>
                          <div
                            class="drivePlus__card__benefits"
                            *ngFor="let benefit of tierBenefitsWithoutRoadtax"
                          >
                            <div class="drivePlus__card__benefits__list">
                              <img
                                src="/assets/icons/check_circle.png"
                                alt=""
                              />
                              <ng-container [ngSwitch]="benefit.code">
                                <ng-container *ngSwitchCase="'RoadTaxDiscount'">
                                  {{
                                    "plans.motorMembership.DrivePlusBenefits." +
                                      benefit.code +
                                      (benefit.maxCapAmount != null
                                        ? "Cap"
                                        : "")
                                      | translate
                                        : {
                                            discountPercentage:
                                              benefit.discountPercentage,
                                            maxCapAmount: benefit.maxCapAmount
                                          }
                                  }}
                                </ng-container>
                                <ng-container
                                  *ngSwitchCase="'NextRenewalDiscount'"
                                >
                                  {{
                                    "plans.motorMembership.DrivePlusBenefits." +
                                      benefit.code
                                      | translate
                                        : {
                                            discountPrice:
                                              getDiscountExternalVoucherEvent(
                                                selectedMotorMembershipString
                                              )
                                          }
                                  }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'EPPDiscount'">
                                  {{
                                    "plans.motorMembership.DrivePlusBenefits." +
                                      benefit.code
                                      | translate
                                        : {
                                            discountPrice: benefit.evaluate
                                          }
                                  }}
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                  {{
                                    "plans.motorMembership.DrivePlusBenefits." +
                                      benefit.code
                                      | translate
                                        : {
                                            protectionPlan:
                                              getInsuranceOrTakafulWording(true)
                                          }
                                  }}
                                </ng-container>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <div id="chip-section">
                  <mat-chip-list>
                    <mat-chip
                      #allAddonChip="matChip"
                      [selected]="true"
                      (click)="allAddonChip.selected = true"
                      (selectionChange)="allAddonChipSelected($event)"
                      >{{ "plans.bundleCategory.all" | translate }}</mat-chip
                    >
                    <mat-chip
                      #popularAddonChip="matChip"
                      (click)="popularAddonChip.selected = true"
                      (selectionChange)="popularAddonChipSelected($event)"
                      >{{
                        "plans.bundleCategory.popular" | translate
                      }}</mat-chip
                    >
                    <!-- MTR-578: TEMPORARILY HIDE FFF BUNDLE -->
                    <mat-chip
                      style="display: none"
                      #floodAddonChip="matChip"
                      [selected]="floodAddonChip.selected || floodChip.selected"
                      (click)="
                        floodAddonChip.selected = true;
                        floodChip.selected = true
                      "
                      >{{
                        "plans.step1Content.floodChip" | translate
                      }}</mat-chip
                    >
                    <!-- MTR-578: TEMPORARILY HIDE FFF BUNDLE -->
                    <mat-chip
                      style="display: none"
                      #femaleAddonChip="matChip"
                      [selected]="
                        femaleAddonChip.selected || femaleChip.selected
                      "
                      (click)="
                        femaleAddonChip.selected = true;
                        femaleChip.selected = true
                      "
                      >{{
                        "plans.step1Content.femaleChip" | translate
                      }}</mat-chip
                    >
                    <!-- MTR-578: TEMPORARILY HIDE FFF BUNDLE -->
                    <mat-chip
                      style="display: none"
                      #familyAddonChip="matChip"
                      [selected]="
                        familyAddonChip.selected || familyChip.selected
                      "
                      (click)="
                        familyAddonChip.selected = true;
                        familyChip.selected = true
                      "
                      >{{
                        "plans.step1Content.familyChip" | translate
                      }}</mat-chip
                    >
                  </mat-chip-list>
                </div>
              </div>

              <div class="addons-container">
                <!-- My Car Plus -->
                <ng-container *ngIf="availableInsurerCarPlus?.length > 0">
                  <mat-card
                    class="addon-card insurer-car-plus"
                    [class.car-plus-selected]="isCarPlusChecked"
                    style="margin-top: 32px"
                  >
                    <div
                      *ngIf="insurerCarPlusSettings.showToggleGroup"
                      class="insurer-car-plus-toggle-group"
                    >
                      <mat-button-toggle-group
                        [value]="
                          selectedAvailableInsurerCarPlus.insurerCustomCode
                        "
                        (change)="onInsurerCarPlusPlanChange($event.value)"
                      >
                        <mat-button-toggle
                          *ngFor="let toggle of availableInsurerCarPlus"
                          [value]="toggle.insurerCustomCode"
                        >
                          {{ "addOn." + toggle.code | translate }}
                        </mat-button-toggle>
                      </mat-button-toggle-group>
                    </div>

                    <div
                      fxLayout="row"
                      fxLayout.lt-sm="column"
                      class="insurer-car-plus-content"
                      [ngClass]="{
                        'with-margin': insurerCarPlusSettings.showToggleGroup
                      }"
                    >
                      <div
                        fxFlex="70"
                        fxFlex.lt-sm="100"
                        fxFlexOrder="1"
                        fxFlexOrder.lt-sm="2"
                      >
                        <div fxLayout="row">
                          <mat-checkbox
                            [(ngModel)]="isCarPlusChecked"
                            [ngModelOptions]="{ standalone: true }"
                            [ngClass]="{
                              'hide-checkbox':
                                !insurerCarPlusSettings.showCheckbox,
                              'no-click': !insurerCarPlusSettings.showCheckbox
                            }"
                          >
                            {{ insurerCarPlusPackage.title | translate }}
                          </mat-checkbox>
                        </div>

                        <div fxLayout="row">
                          {{ insurerCarPlusPackage.description | translate }}
                        </div>

                        <div
                          *ngIf="insurerCarPlusSettings.showPrice"
                          fxLayout="row"
                          class="value insurer-car-plus-price"
                        >
                          <span>RM</span>
                          {{
                            getPrice(selectedAvailableInsurerCarPlus)
                              | number : "1.2-2"
                          }}
                        </div>
                      </div>

                      <div
                        fxFlex="30"
                        fxFlex.lt-sm="100"
                        fxFlexOrder="2"
                        fxFlexOrder.lt-sm="1"
                        fxLayoutAlign="center center"
                      >
                        <img
                          style="width: 100%"
                          src="https://storage.googleapis.com/ps-asset/ps_logos/chubb_drive_plus.png"
                        />
                      </div>
                    </div>

                    <div class="insurer-car-plus-benefit">
                      <div fxLayout="row">
                        <span class="title">
                          {{ "common.benefits" | translate }}
                        </span>
                      </div>

                      <div *ngFor="let benefit of displayedBenefits">
                        <div fxLayout="row" class="car-plus-benefit-row">
                          <img
                            *ngIf="benefit.image"
                            src="{{ benefit.image }}"
                          />

                          <mat-icon *ngIf="benefit.icon" class="color-green">
                            {{ benefit.icon }}
                          </mat-icon>

                          <span [innerHTML]="benefit.text | translate"></span>
                        </div>
                      </div>

                      <div class="car-plus-tnc">
                        {{ "addOn.ChubbCarPlusTNC" | translate }}
                      </div>

                      <!-- View more button -->
                      <div
                        *ngIf="
                          insurerCarPlusPackage?.benefits?.length >
                          benefitsLimit
                        "
                        class="toggle-benefits"
                      >
                        <button
                          mat-button
                          (click)="toggleInsurerCarPlusBenefits()"
                          class="view-more-button"
                        >
                          <mat-icon>
                            {{
                              showAllBenefits
                                ? "keyboard_arrow_up"
                                : "keyboard_arrow_down"
                            }}
                          </mat-icon>

                          {{
                            showAllBenefits
                              ? ("common.viewLess" | translate)
                              : ("common.viewMore" | translate)
                          }}
                        </button>
                      </div>
                    </div>
                  </mat-card>
                </ng-container>

                <ng-container *ngFor="let addOn of addOnListToDisplay">
                  <!-- Included Addon: Always show on top -->
                  <ng-container *ngIf="addOn.included">
                    <app-addon-card
                      [title]="'addOn.' + addOn.code | translate"
                      [tooltip]="'addOn.' + addOn.code + 'Tooltip' | translate"
                      [code]="addOn.code"
                      [price]="addOn.evaluate"
                      [label]="false"
                      [includedAddOn]="true"
                      [desc]="'addOn.' + addOn?.code + 'Desc' | translate"
                      img="https://storage.googleapis.com/dev-ps-asset/motor/FFF/Add-on/{{
                        addOn.category
                      }}.png"
                      [addOnSelected]="hasSelectedCategory(addOn.category)"
                      (toggleCheckbox)="toggleAddOn($event, addOn)"
                    ></app-addon-card>
                  </ng-container>
                  <ng-container *ngIf="!addOn.included">
                    <ng-container *ngIf="addOn.isBundleAddOn">
                      <ng-container *ngIf="addOn.category == 'Flood'">
                        <app-addon-card
                          [title]="
                            'plans.bundleAddOns.' + addOn.code | translate
                          "
                          [desc]="
                            'plans.bundleAddOns.' + addOn.code + 'Desc'
                              | translate
                                : {
                                    sumInsured:
                                      selectedQuotation?.sumInsured
                                      | number : '1.2-2'
                                  }
                          "
                          [tooltip]="
                            'plans.bundleAddOns.' + addOn.code + 'TT'
                              | translate
                          "
                          [price]="addOn.evaluate"
                          [label]="addOn.code == 'FloodCoverage' ? false : true"
                          [img]="addOn.imageUrl"
                          [selected]="getIsBundleSelected(addOn.motorBundleId)"
                          [addOnSelected]="getIsBundleAddOnSelected(addOn.code)"
                          (toggleCheckbox)="
                            toggleBundleAddonCheckbox($event, addOn)
                          "
                          *ngIf="
                            floodAddonChip.selected ||
                            allAddonChip.selected ||
                            (addOn.isPopular && popularAddonChip.selected)
                          "
                        ></app-addon-card>
                      </ng-container>
                      <ng-container *ngIf="addOn.category == 'Female'">
                        <app-addon-card
                          [title]="
                            'plans.bundleAddOns.' + addOn.code | translate
                          "
                          [desc]="
                            'plans.bundleAddOns.' + addOn.code + 'Desc'
                              | translate
                          "
                          [tooltip]="
                            'plans.bundleAddOns.' + addOn.code + 'TT'
                              | translate
                          "
                          [price]="addOn.evaluate"
                          [label]="true"
                          [img]="addOn.imageUrl"
                          [selected]="getIsBundleSelected(addOn.motorBundleId)"
                          [addOnSelected]="getIsBundleAddOnSelected(addOn.code)"
                          (toggleCheckbox)="
                            toggleBundleAddonCheckbox($event, addOn)
                          "
                          *ngIf="
                            femaleAddonChip.selected ||
                            allAddonChip.selected ||
                            (addOn.isPopular && popularAddonChip.selected)
                          "
                        ></app-addon-card>
                      </ng-container>
                      <ng-container *ngIf="addOn.category == 'Family'">
                        <app-addon-card
                          [title]="
                            'plans.bundleAddOns.' + addOn.code | translate
                          "
                          [desc]="
                            'plans.bundleAddOns.' + addOn.code + 'Desc'
                              | translate
                          "
                          [tooltip]="
                            'plans.bundleAddOns.' + addOn.code + 'TT'
                              | translate
                          "
                          [price]="addOn.evaluate"
                          [label]="true"
                          [img]="addOn.imageUrl"
                          [selected]="getIsBundleSelected(addOn.motorBundleId)"
                          [addOnSelected]="getIsBundleAddOnSelected(addOn.code)"
                          (toggleCheckbox)="
                            toggleBundleAddonCheckbox($event, addOn)
                          "
                          *ngIf="
                            familyAddonChip.selected ||
                            allAddonChip.selected ||
                            (addOn.isPopular && popularAddonChip.selected)
                          "
                        ></app-addon-card>
                      </ng-container>
                      <!-- Add on that shows on all category -->
                      <ng-container
                        *ngIf="
                          addOn.category !== 'Flood' &&
                          addOn.category !== 'Female' &&
                          addOn.category !== 'Family'
                        "
                      >
                        <app-addon-card
                          [title]="
                            'plans.bundleAddOns.' + addOn.code | translate
                          "
                          [desc]="
                            'plans.bundleAddOns.' + addOn.code + 'Desc'
                              | translate
                          "
                          [tooltip]="
                            'plans.bundleAddOns.' + addOn.code + 'TT'
                              | translate
                          "
                          [price]="addOn.evaluate"
                          [label]="false"
                          [img]="addOn.imageUrl"
                          [selected]="isAnyBundleSelected()"
                          [addOnSelected]="getIsBundleAddOnSelected(addOn.code)"
                          (toggleCheckbox)="
                            toggleBundleAddonCheckbox($event, addOn)
                          "
                        ></app-addon-card>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!addOn.isBundleAddOn">
                      <ng-container
                        *ngIf="addOn.isRoadTaxRenewal && showRoadTaxAddOn"
                      >
                        <app-addon-card
                          [class]="'roadTaxRenewalClass'"
                          [drivePlusSelected]="hasSelectedMotorMembership"
                          [drivePlusRoadtaxPrice]="getDrivePlusRoadtaxPrice()"
                          [title]="'dashboard.roadTaxRenewTitle' | translate"
                          [desc]="'addOn.roadTaxDesc' | translate"
                          [tooltip]="'addOn.roadTaxTT' | translate"
                          [price]="getRoadtaxDisplayPrice()"
                          img="https://storage.googleapis.com/dev-ps-asset/Car_Insurance/icons/roadtax-logo.png"
                          [addOnSelected]="
                            addOnFormGroup.value?.isIncludeRoadtax
                          "
                          (toggleCheckbox)="toggleRoadTax($event)"
                          [isRoadtaxPromo]="roadTaxPromoPrice != null"
                          [roadtaxPromoPrice]="roadTaxPromoPrice"
                        >
                          <div slot="fullWidth" class="roadtax-content">
                            <mat-radio-group
                              *ngIf="showRoadTaxList"
                              (change)="radioDigitalRoadTaxChange($event)"
                              class="roadtax-radio-group"
                            >
                              <mat-radio-button
                                value="digitalRoadTax"
                                [checked]="
                                  personalInfo.isMalaysian &&
                                  !personalInfo.isCompany
                                "
                                *ngIf="
                                  personalInfo.isMalaysian &&
                                  !personalInfo.isCompany
                                "
                              >
                                <ng-container>
                                  <div
                                    fxLayout="column"
                                    fxLayoutAlign=" flex-start"
                                  >
                                    <div
                                      class="title"
                                      fxFlex
                                      [innerHTML]="
                                        'addOn.digitalRoadTax' | translate
                                      "
                                    ></div>
                                    <div class="value sub-right text-right">
                                      <!-- <del>RM 8.00</del> -->
                                      <span class="color-free">
                                        {{ "capitalFree" | translate }}
                                      </span>
                                      {{ "handlingFee" | translate }}
                                    </div>
                                  </div>
                                </ng-container>
                              </mat-radio-button>
                              <mat-radio-button
                                value="roadTax"
                                [checked]="
                                  !personalInfo.isMalaysian ||
                                  personalInfo.isCompany
                                "
                                *ngIf="
                                  !personalInfo.isMalaysian ||
                                  personalInfo.isCompany
                                "
                              >
                                <ng-container>
                                  <div
                                    fxLayout="column"
                                    fxLayoutAlign=" flex-start"
                                  >
                                    <div
                                      class="title"
                                      fxFlex
                                      [innerHTML]="
                                        'addOn.physicalRoadtaxInnerHTML'
                                          | translate
                                      "
                                    ></div>
                                    <div
                                      *ngIf="hasSelectedMotorMembership"
                                      class="value sub-right text-right"
                                    >
                                      RM
                                      {{
                                        membershipRTHandlingFee
                                          | number : "1.2-2"
                                      }}
                                      {{ "handlingFee" | translate }}
                                    </div>
                                    <div
                                      *ngIf="!hasSelectedMotorMembership"
                                      class="value sub-right text-right"
                                    >
                                      RM 15.00 {{ "handlingFee" | translate }}
                                    </div>
                                  </div>
                                </ng-container>
                              </mat-radio-button>
                              <ng-container
                                *ngIf="
                                  addOnFormGroup.value?.isIncludeRoadtax &&
                                  showRoadTaxList
                                "
                              >
                                <div fxLayout="row">
                                  <mat-checkbox
                                    fxFlex
                                    color="warn"
                                    formControlName="isNotBlacklisted"
                                    class="blacklist"
                                  >
                                    <div
                                      [innerHTML]="
                                        'addOn.isNotBlacklistedBR' | translate
                                      "
                                    ></div>
                                  </mat-checkbox>
                                </div>
                              </ng-container>
                            </mat-radio-group>
                            <div
                              *ngIf="
                                addOnFormGroup.value?.isIncludeRoadtax &&
                                (!personalInfo.isMalaysian ||
                                  personalInfo.isCompany)
                              "
                              class="roadtax-content__notice"
                            >
                              <div class="roadtax-content__notice__title">
                                {{ "addOn.roadTaxNoticeTitle" | translate }}
                              </div>
                              <div
                                class="roadtax-content__notice__desc"
                                [innerHTML]="
                                  'addOn.roadTaxNoticeDesc' | translate
                                "
                              ></div>
                            </div>
                          </div>
                        </app-addon-card>
                      </ng-container>
                      <ng-container *ngIf="!addOn.isRoadTaxRenewal">
                        <ng-container
                          *ngIf="
                            addOn.category !== 'Windshield' &&
                            addOn.category !== 'Drivers' &&
                            addOn.category !== 'LLTP' &&
                            addOn.category !== 'MPA' &&
                            addOn.category !== 'PA' &&
                            addOn.category !== 'MERW' &&
                            addOn.category !== 'PSXTRA' &&
                            addOn.category !== 'Flood' &&
                            addOn.category !== 'CART' &&
                            addOn.category !== 'GCKT' &&
                            addOn.category !== 'VA'
                          "
                        >
                          <app-addon-card
                            [class]="addOn.category"
                            [title]="'addOn.' + addOn.displayCode | translate"
                            [tooltip]="
                              'addOn.' + addOn.code + 'Tooltip' | translate
                            "
                            [price]="addOn.evaluate"
                            [label]="false"
                            [desc]="
                              'addOn.' + addOn.code + 'Desc'
                                | translate
                                  : {
                                      sumInsured:
                                        selectedQuotation?.sumInsured
                                        | number : '1.2-2'
                                    }
                            "
                            img="https://storage.googleapis.com/dev-ps-asset/motor/FFF/Add-on/{{
                              addOn.category
                            }}.png"
                            [addOnSelected]="
                              hasSelectedCategory(addOn.category)
                            "
                            (toggleCheckbox)="toggleAddOn($event, addOn)"
                          ></app-addon-card>
                        </ng-container>
                        <ng-container *ngIf="addOn.category == 'Windshield'">
                          <app-addon-card
                            [title]="'addOn.' + addOn.displayCode | translate"
                            [desc]="
                              'addOn.' + addOn.displayCode + 'Desc' | translate
                            "
                            [tooltip]="
                              'addOn.' + addOn.code + 'Tooltip' | translate
                            "
                            [price]="
                              getPrice(addOn, addOnFormGroup.value.windshield)
                            "
                            [label]="false"
                            img="https://storage.googleapis.com/dev-ps-asset/motor/FFF/Add-on/{{
                              addOn.category
                            }}.png"
                            [addOnSelected]="
                              hasSelectedCategory(addOn.category)
                            "
                            (toggleCheckbox)="toggleAddOn($event, addOn)"
                          >
                            <div
                              slot="fullWidth"
                              class="roadtax-content"
                              *ngIf="
                                (selectedQuotation.code == 'Zurich' ||
                                  selectedQuotation.code == 'Zurich_Takaful') &&
                                !personalInfo.isCompany
                              "
                            >
                              <ng-container *ngIf="isAddOnSelected(addOn)">
                                <div
                                  fxLayout="column"
                                  fxLayoutAlign=" flex-start"
                                >
                                  <mat-checkbox
                                    fxFlex
                                    color="warn"
                                    formControlName="isWindshieldExceeded"
                                    class="windshield-exceed"
                                  >
                                    <div
                                      [innerHTML]="
                                        'addOn.isWindshieldExceededBR'
                                          | translate
                                      "
                                    ></div>
                                  </mat-checkbox>
                                </div>
                              </ng-container>
                            </div>

                            <div slot="fullWidth">
                              <ng-container *ngIf="isAddOnSelected(addOn)">
                                <div class="slider-desc">
                                  {{ "addOn.coverage" | translate }} :
                                </div>
                                <app-range-slider
                                  [max]="getMinMaxWindscreenPrice(addOn, 'max')"
                                  [min]="getMinMaxWindscreenPrice(addOn, 'min')"
                                  [step]="50"
                                  [variantSmall]="true"
                                  formControlName="windshield"
                                  [maxError]="
                                    'addOn.maxWindscreenError'
                                      | translate
                                        : {
                                            amount:
                                              getMinMaxWindscreenPrice(
                                                addOn,
                                                'max'
                                              )
                                              | currency
                                                : 'RM'
                                                : 'symbol'
                                                : '1.2-2'
                                          }
                                  "
                                  [minError]="
                                    'addOn.minWindscreenError'
                                      | translate
                                        : {
                                            amount:
                                              getMinMaxWindscreenPrice(
                                                addOn,
                                                'min'
                                              )
                                              | currency
                                                : 'RM'
                                                : 'symbol'
                                                : '1.2-2'
                                          }
                                  "
                                ></app-range-slider>
                              </ng-container>
                            </div>
                          </app-addon-card>
                        </ng-container>

                        <ng-container *ngIf="addOn.category == 'Drivers'">
                          <ng-container *ngIf="driverAddOnCount === 1">
                            <app-addon-card
                              [title]="'addOn.' + addOn.displayCode | translate"
                              [desc]="
                                (isZurichQuotation
                                  ? 'addOn.' + addOn.displayCode + 'Desc'
                                  : ''
                                ) | translate
                              "
                              [tooltip]="
                                'addOn.' + addOn.code + 'Tooltip' | translate
                              "
                              [price]="getPrice(addOn) | number : '1.2-2'"
                              [label]="false"
                              img="https://storage.googleapis.com/dev-ps-asset/motor/FFF/Add-on/{{
                                addOn.category
                              }}.png"
                              [addOnSelected]="
                                hasSelectedCategory(addOn.category)
                              "
                              (toggleCheckbox)="toggleAddOn($event, addOn)"
                            >
                            </app-addon-card>
                          </ng-container>
                          <ng-container *ngIf="driverAddOnCount !== 1">
                            <app-addon-card
                              [title]="'addOn.AdditionalDrivers' | translate"
                              [tooltip]="
                                'addOn.' + addOn.code + 'Tooltip' | translate
                              "
                              [price]="null"
                              [label]="false"
                              img="https://storage.googleapis.com/dev-ps-asset/motor/FFF/Add-on/{{
                                addOn.category
                              }}.png"
                              [addOnSelected]="
                                hasSelectedCategory(addOn.category)
                              "
                              (toggleCheckbox)="driverRadioChange(addOn, true)"
                            >
                              <div slot="fullWidth">
                                <mat-radio-group
                                  *ngIf="hasSelectedCategory('Drivers')"
                                  (change)="
                                    selectedDriverRadioChange($event.value)
                                  "
                                  class="roadtax-radio-group"
                                >
                                  <mat-radio-button
                                    *ngFor="
                                      let item of driversAddOn;
                                      let first = first
                                    "
                                    [value]="item"
                                    [checked]="first"
                                  >
                                    <ng-container
                                      *ngIf="item.code !== 'AdditionalDrivers'"
                                    >
                                      <div fxLayout="column">
                                        <div
                                          class="title"
                                          fxFlex
                                          *ngIf="
                                            selectedQuotation.code != 'Zurich'
                                          "
                                        >
                                          {{
                                            "addOn.UnlimitedDrivers" | translate
                                          }}
                                        </div>
                                        <div
                                          class="title"
                                          fxFlex
                                          *ngIf="
                                            selectedQuotation.code == 'Zurich'
                                          "
                                        >
                                          {{
                                            "addOn.UnlimitedDriversZurich"
                                              | translate
                                          }}
                                        </div>
                                        <div class="value sub-right">
                                          <span>RM</span>
                                          {{
                                            getPrice(item, item.evaluate)
                                              | number : "1.2-2"
                                          }}
                                        </div>
                                      </div>
                                    </ng-container>

                                    <ng-container
                                      *ngIf="item.code === 'AdditionalDrivers'"
                                    >
                                      <div fxLayout="column">
                                        <div class="title" fxFlex>
                                          {{
                                            "addOn.additionalDriver" | translate
                                          }}
                                        </div>
                                        <div fxLayout="row">
                                          <div
                                            class="value sub-right"
                                            *ngIf="
                                              getDriversFormArray()?.controls
                                                .length > 1;
                                              else freeDriverText
                                            "
                                          >
                                            <span>RM</span>
                                            {{
                                              getPrice(
                                                item,
                                                getDriversFormArray()?.controls
                                                  .length
                                              ) | number : "1.2-2"
                                            }}
                                          </div>
                                          <ng-template #freeDriverText>
                                            <div class="value sub-right">
                                              {{ "addOn.free" | translate }}
                                              <span
                                                [translate]="
                                                  'addOn.additionalDriverDesc'
                                                "
                                                [translateParams]="{
                                                  val:
                                                    maxFreeDriver ??
                                                    translate.instant(
                                                      'number.1'
                                                    )
                                                }"
                                              ></span>
                                            </div>
                                          </ng-template>
                                          <mat-icon
                                            class="tooltip-icon"
                                            [matMenuTriggerFor]="
                                              AdditionalDriversTooltip
                                            "
                                            #AdditionalDriversTrigger="matMenuTrigger"
                                            (mouseenter)="
                                              AdditionalDriversTrigger.openMenu()
                                            "
                                          >
                                            info
                                          </mat-icon>
                                        </div>
                                      </div>
                                      <mat-menu
                                        #AdditionalDriversTooltip="matMenu"
                                        [overlapTrigger]="false"
                                        class="tooltip-popover"
                                      >
                                        <span
                                          (mouseleave)="
                                            AdditionalDriversTrigger.closeMenu()
                                          "
                                        >
                                          {{
                                            "addOn.AdditionalDriversTooltip"
                                              | translate
                                          }}
                                        </span>
                                      </mat-menu>
                                    </ng-container>
                                  </mat-radio-button>
                                </mat-radio-group>
                                <ng-container
                                  *ngIf="hasSelectedCode('AdditionalDrivers')"
                                >
                                  <div
                                    formArrayName="drivers"
                                    *ngFor="
                                      let item of getDriversFormArray()
                                        ?.controls;
                                      let i = index
                                    "
                                  >
                                    <br />
                                    <ng-container [formGroupName]="i">
                                      <div
                                        fxLayout="row"
                                        fxLayoutAlign=" center"
                                      >
                                        <div class="driver-count bold">
                                          {{
                                            "addOn.additionalDriver" | translate
                                          }}
                                          #{{ i + 1 }}
                                        </div>
                                        <div
                                          class="driver-divider"
                                          fxFlex
                                        ></div>
                                        <button
                                          class="driver-delete"
                                          (click)="deleteDriver(i)"
                                          mat-icon-button
                                          *ngIf="i !== 0"
                                          type="button"
                                        >
                                          <mat-icon>delete_outline</mat-icon>
                                        </button>
                                      </div>

                                      <br />

                                      <div class="form-wrapper">
                                        <div>
                                          <mat-form-field appearance="outline">
                                            <mat-label
                                              >{{ "common.name" | translate }}
                                            </mat-label>
                                            <input
                                              matInput
                                              autocomplete="off"
                                              formControlName="name"
                                            />
                                            <mat-error>
                                              {{ "common.name" | translate }}
                                              {{
                                                getFormArrayControlError(
                                                  i,
                                                  "name"
                                                )
                                                  | inputError
                                                  | translate
                                              }}
                                            </mat-error>
                                          </mat-form-field>

                                          <div class="sub-form-wrapper">
                                            <mat-form-field
                                              class="form-dropdown"
                                              appearance="outline"
                                            >
                                              <mat-label
                                                >{{
                                                  "common.idType" | translate
                                                }}
                                              </mat-label>
                                              <mat-select
                                                formControlName="idType"
                                              >
                                                <mat-option
                                                  *ngFor="
                                                    let item of idTypeList
                                                  "
                                                  [value]="item.codeValue"
                                                >
                                                  {{ item.codeDesc }}
                                                </mat-option>
                                              </mat-select>
                                            </mat-form-field>

                                            <mat-form-field
                                              class="form-input"
                                              appearance="outline"
                                            >
                                              <mat-label
                                                >{{ "common.idNo" | translate }}
                                              </mat-label>
                                              <input
                                                matInput
                                                autocomplete="off"
                                                [mask]="
                                                  item.get('idType').value ===
                                                  'IC_NO'
                                                    ? '000000000000'
                                                    : ''
                                                "
                                                formControlName="identityNo"
                                              />
                                              <mat-error>
                                                {{ "common.idNo" | translate }}
                                                {{
                                                  getFormArrayControlError(
                                                    i,
                                                    "identityNo"
                                                  )
                                                    | inputError
                                                    | translate
                                                }}
                                              </mat-error>
                                            </mat-form-field>
                                          </div>

                                          <mat-form-field appearance="outline">
                                            <mat-label
                                              >{{ "common.dob" | translate }}
                                            </mat-label>
                                            <input
                                              matInput
                                              readonly
                                              [matDatepicker]="picker"
                                              formControlName="dob"
                                              (click)="picker.open()"
                                              [max]="maxDob"
                                            />
                                            <mat-datepicker-toggle
                                              matSuffix
                                              [for]="picker"
                                            ></mat-datepicker-toggle>
                                            <mat-datepicker
                                              #picker
                                            ></mat-datepicker>
                                            <mat-error>
                                              {{ "common.dob" | translate }}
                                              {{
                                                getFormArrayControlError(
                                                  i,
                                                  "dob"
                                                )
                                                  | inputError
                                                  | translate
                                              }}
                                            </mat-error>
                                          </mat-form-field>
                                        </div>

                                        <div class="additional-radio-btn">
                                          <mat-label
                                            >{{ "common.gender" | translate }}
                                          </mat-label>
                                          <mat-radio-group
                                            aria-label="Select an option"
                                            formControlName="gender"
                                          >
                                            <mat-radio-button
                                              [value]="genderOption.male"
                                            >
                                              {{ "common.M" | translate }}
                                            </mat-radio-button>
                                            <mat-radio-button
                                              [value]="genderOption.female"
                                            >
                                              {{ "common.F" | translate }}
                                            </mat-radio-button>
                                          </mat-radio-group>
                                        </div>

                                        <div class="additional-radio-btn">
                                          <mat-label
                                            >{{
                                              "common.maritalStatus" | translate
                                            }}
                                          </mat-label>
                                          <mat-radio-group
                                            aria-label="Select an option"
                                            formControlName="maritalStatus"
                                          >
                                            <mat-radio-button
                                              [value]="
                                                maritalStatusOption.single
                                              "
                                            >
                                              {{ "common.Single" | translate }}
                                            </mat-radio-button>
                                            <mat-radio-button
                                              [value]="
                                                maritalStatusOption.married
                                              "
                                            >
                                              {{ "common.Married" | translate }}
                                            </mat-radio-button>
                                          </mat-radio-group>
                                        </div>

                                        <mat-form-field appearance="outline">
                                          <mat-label>{{
                                            "common.relationship" | translate
                                          }}</mat-label>
                                          <mat-select
                                            formControlName="relationship"
                                            placeholder="Please select"
                                          >
                                            <mat-option
                                              *ngFor="
                                                let item of relationshipList
                                              "
                                              [value]="item.id"
                                            >
                                              {{ item.name | translate }}
                                            </mat-option>
                                          </mat-select>
                                          <mat-error>
                                            {{
                                              "common.relationship" | translate
                                            }}
                                            {{
                                              getFormArrayControlError(
                                                i,
                                                "relationship"
                                              )
                                                | inputError
                                                | translate
                                            }}
                                          </mat-error>
                                        </mat-form-field>
                                      </div>
                                    </ng-container>
                                  </div>
                                  <button
                                    *ngIf="
                                      !maxAdditionalDriver ||
                                      getDriversFormArray()?.length <
                                        maxAdditionalDriver
                                    "
                                    (click)="addDriver()"
                                    type="button"
                                    mat-stroked-button
                                    class="add-driver-btn"
                                  >
                                    <mat-icon>add_circle</mat-icon>
                                    {{ "addOn.addDriver" | translate }}
                                  </button>
                                </ng-container>
                              </div>
                            </app-addon-card>
                          </ng-container>
                        </ng-container>

                        <ng-container *ngIf="addOn.category == 'LLTP'">
                          <app-addon-card
                            [title]="'addOn.' + addOn.displayCode | translate"
                            [desc]="
                              'addOn.' + addOn.displayCode + 'Desc' | translate
                            "
                            [tooltip]="
                              'addOn.' + addOn.code + 'Tooltip' | translate
                            "
                            [price]="getPrice(addOn, this.numberOfLltpSeats)"
                            [label]="false"
                            img="https://storage.googleapis.com/dev-ps-asset/motor/FFF/Add-on/{{
                              addOn.category
                            }}.png"
                            [addOnSelected]="
                              hasSelectedCategory(addOn.category)
                            "
                            (toggleCheckbox)="toggleAddOn($event, addOn)"
                          >
                            <div slot="fullWidth">
                              <ng-container *ngIf="isAddOnSelected(addOn)">
                                <div class="mt-md">
                                  {{ "addOn.coverage" | translate }} :
                                  <label class="seat-label">
                                    {{ numberOfLltpSeats }}
                                    {{ "common.seats" | translate }}
                                  </label>
                                </div>
                              </ng-container>
                            </div>
                          </app-addon-card>
                        </ng-container>

                        <ng-container *ngIf="addOn.category == 'PA'">
                          <ng-container
                            *ngIf="addOn.customCode == 'UnlimitedTowing_PA'"
                          >
                            <app-addon-card
                              [title]="
                                'addOn.' +
                                addOn.customCode +
                                (selectedQuotation.code == 'Zurich' || selectedQuotation.code == 'Zurich_Takaful' ? '_Zurich' : '')
                               | translate
                              "
                              [tooltip]="
                                'addOn.' + addOn.customCode + 'Tooltip'
                                  | translate
                              "
                              [price]="
                                getPrice(addOn, this.numberOfLltpSeats)
                                  | number : '1.2-2'
                              "
                              [label]="false"
                              [desc]="
                                'addOn.' + addOn.customCode + 'Desc'
                                  | translate
                                    : {
                                        sumInsured:
                                          selectedQuotation?.sumInsured
                                          | number : '1.2-2'
                                      }
                              "
                              img="https://storage.googleapis.com/dev-ps-asset/motor/FFF/Add-on/{{
                                addOn.category
                              }}.png"
                              [addOnSelected]="
                                hasSelectedCategory(addOn.category)
                              "
                              (toggleCheckbox)="toggleAddOn($event, addOn)"
                            >
                            </app-addon-card>
                          </ng-container>
                          <ng-container
                            *ngIf="addOn.customCode != 'UnlimitedTowing_PA'"
                          >
                            <app-addon-card
                              [title]="'addOn.' + addOn.displayCode | translate"
                              [tooltip]="
                                'addOn.' + addOn.code + 'Tooltip' | translate
                              "
                              [price]="getPrice(addOn) | number : '1.2-2'"
                              [label]="false"
                              [desc]="
                                'addOn.' + addOn.displayCode + 'Desc'
                                  | translate
                                    : {
                                        sumInsured:
                                          selectedQuotation?.sumInsured
                                          | number : '1.2-2'
                                      }
                              "
                              img="https://storage.googleapis.com/dev-ps-asset/motor/FFF/Add-on/{{
                                addOn.category
                              }}.png"
                              [addOnSelected]="
                                hasSelectedCategory(addOn.category)
                              "
                              (toggleCheckbox)="toggleAddOn($event, addOn)"
                            >
                            </app-addon-card>
                          </ng-container>
                        </ng-container>

                        <ng-container *ngIf="addOn.category == 'MERW'">
                          <app-addon-card
                            [title]="'addOn.' + addOn.code | translate"
                            [tooltip]="
                              'addOn.' + addOn.code + 'Tooltip' | translate
                            "
                            [price]="getPrice(addOn) | number : '1.2-2'"
                            [label]="false"
                            [desc]="
                              'addOn.' + addOn.code + 'Desc'
                                | translate
                                  : {
                                      sumInsured:
                                        selectedQuotation?.sumInsured
                                        | number : '1.2-2'
                                    }
                            "
                            img="https://storage.googleapis.com/dev-ps-asset/motor/FFF/Add-on/{{
                              addOn.category
                            }}.png"
                            [addOnSelected]="
                              hasSelectedCategory(addOn.category)
                            "
                            (toggleCheckbox)="toggleAddOn($event, addOn)"
                          ></app-addon-card>
                        </ng-container>

                        <ng-container *ngIf="addOn.category == 'PSXTRA'">
                          <app-addon-card
                            [title]="'addOn.' + addOn.code | translate"
                            [price]="getPrice(addOn) | number : '1.2-2'"
                            [label]="false"
                            [code]="addOn.category"
                            [desc]="
                              'addOn.' + addOn.code + 'Desc'
                                | translate
                                  : {
                                      sumInsured:
                                        selectedQuotation?.sumInsured
                                        | number : '1.2-2'
                                    }
                            "
                            img="https://storage.googleapis.com/dev-ps-asset/motor/{{
                              addOn.category
                            }}/{{ addOn.code }}.png"
                            [brochure]="
                              'https://storage.googleapis.com/dev-ps-asset/motor/' +
                              addOn.category +
                              '/Brochures/' +
                              addOn.category +
                              '_' +
                              addOn.code +
                              '_desktop_' +
                              translate.currentLang
                            "
                            [brochureMobile]="
                              'https://storage.googleapis.com/dev-ps-asset/motor/' +
                              addOn.category +
                              '/Brochures/' +
                              addOn.category +
                              '_' +
                              addOn.code +
                              '_mobile_' +
                              translate.currentLang
                            "
                            [addOnSelected]="hasSelectedCode(addOn.code)"
                            (toggleCheckbox)="toggleAddOn($event, addOn)"
                          ></app-addon-card>
                        </ng-container>

                        <ng-container *ngIf="addOn.category == 'Flood'">
                          <app-addon-card
                            [class]="addOn.category"
                            [title]="'addOn.' + addOn.displayCode | translate"
                            [tooltip]="
                              'addOn.' + addOn.code + 'Tooltip' | translate
                            "
                            [price]="getPrice(addOn)"
                            [label]="false"
                            [desc]="
                              'addOn.' + addOn.displayCode + 'Desc'
                                | translate
                                  : {
                                      sumInsured:
                                        selectedQuotation?.sumInsured
                                        | number : '1.2-2'
                                    }
                            "
                            img="https://storage.googleapis.com/dev-ps-asset/motor/FFF/Add-on/{{
                              addOn.category
                            }}.png"
                            [addOnSelected]="
                              hasSelectedCategory(addOn.category)
                            "
                            (toggleCheckbox)="toggleAddOn($event, addOn)"
                          ></app-addon-card>
                        </ng-container>

                        <ng-container *ngIf="addOn.category == 'CART'">
                          <app-addon-card
                            [title]="'addOn.' + addOn.code | translate"
                            [desc]="'addOn.' + addOn.code + 'Desc' | translate"
                            [price]="getPrice(addOn)"
                            [label]="false"
                            img="https://storage.googleapis.com/dev-ps-asset/motor/FFF/Add-on/{{
                              addOn.category
                            }}.png"
                            [addOnSelected]="
                              hasSelectedCategory(addOn.category)
                            "
                            (toggleCheckbox)="toggleAddOn($event, addOn)"
                          >
                            <div slot="fullWidth">
                              <ng-container *ngIf="isAddOnSelected(addOn)">
                                <div>
                                  <mat-form-field
                                    class="cart-day-dropdown"
                                    appearance="outline"
                                  >
                                    <mat-label>{{
                                      "common.days" | translate
                                    }}</mat-label>
                                    <mat-select formControlName="cartDays">
                                      <mat-option
                                        *ngFor="let item of cartDayList"
                                        [value]="item.codeValue"
                                      >
                                        {{
                                          item.codeDesc +
                                            " " +
                                            ("common.day" | translate)
                                        }}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>

                                <div>
                                  <mat-form-field appearance="outline">
                                    <mat-label>{{
                                      "common.dailyCoverage" | translate
                                    }}</mat-label>
                                    <mat-select
                                      formControlName="cartDailyCoverage"
                                    >
                                      <mat-option
                                        *ngFor="
                                          let item of cartDailyCoverageList
                                        "
                                        [value]="item.codeValue"
                                      >
                                        {{ item.codeDesc }}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                              </ng-container>
                            </div>
                          </app-addon-card>
                        </ng-container>

                        <ng-container *ngIf="addOn.category == 'GCKT'">
                          <app-addon-card
                            [title]="'addOn.' + addOn.code | translate"
                            [desc]="'addOn.' + addOn.code + 'Desc' | translate"
                            [price]="getPrice(addOn, addOnFormGroup.value.gckt)"
                            [label]="false"
                            img="https://storage.googleapis.com/dev-ps-asset/motor/FFF/Add-on/{{
                              addOn.category
                            }}.png"
                            [addOnSelected]="
                              hasSelectedCategory(addOn.category)
                            "
                            (toggleCheckbox)="toggleAddOn($event, addOn)"
                          >
                            <div slot="fullWidth">
                              <ng-container *ngIf="isAddOnSelected(addOn)">
                                <div class="slider-desc">
                                  {{ "addOn.coverage" | translate }} :
                                </div>
                                <app-range-slider
                                  [isMaxUnlimited]="true"
                                  [min]="this.minGCKTCoverage"
                                  [step]="50"
                                  [variantSmall]="true"
                                  formControlName="gckt"
                                  [minError]="
                                    'addOn.MinGCKTError'
                                      | translate
                                        : {
                                            amount:
                                              this.minGCKTCoverage
                                              | currency
                                                : 'RM'
                                                : 'symbol'
                                                : '1.2-2'
                                          }
                                  "
                                ></app-range-slider>
                              </ng-container>
                            </div>
                          </app-addon-card>
                        </ng-container>

                        <ng-container *ngIf="addOn.category == 'VA'">
                          <app-addon-card
                            [title]="'addOn.' + addOn.code | translate"
                            [desc]="'addOn.' + addOn.code + 'Desc' | translate"
                            [tooltip]="
                              'addOn.' + addOn.code + 'Tooltip' | translate
                            "
                            [price]="getPrice(addOn, addOnFormGroup.value.va)"
                            [label]="false"
                            img="https://storage.googleapis.com/dev-ps-asset/motor/FFF/Add-on/{{
                              addOn.category
                            }}.png"
                            [addOnSelected]="
                              hasSelectedCategory(addOn.category)
                            "
                            (toggleCheckbox)="toggleAddOn($event, addOn)"
                          >
                            <div slot="fullWidth">
                              <ng-container *ngIf="isAddOnSelected(addOn)">
                                <div class="slider-desc">
                                  {{ "addOn.coverage" | translate }} :
                                </div>
                                <app-range-slider
                                  [isMaxUnlimited]="true"
                                  [min]="this.minVACoverage"
                                  [step]="50"
                                  [variantSmall]="true"
                                  formControlName="va"
                                  [minError]="
                                    'addOn.MinVAError'
                                      | translate
                                        : {
                                            amount:
                                              this.minVACoverage
                                              | currency
                                                : 'RM'
                                                : 'symbol'
                                                : '1.2-2'
                                          }
                                  "
                                ></app-range-slider>
                              </ng-container>
                            </div>
                          </app-addon-card>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </div>

            <div class="btn-group-container">
              <button mat-stroked-button matStepperPrevious>
                {{ "common.back" | translate }}
              </button>
              <button mat-flat-button (click)="onNextClick()">
                {{ "common.continue" | translate }}
              </button>
            </div>
          </div>
          <div class="sidebar-container">
            <app-expandable-card
              [forCarDetails]="true"
              [title]="'common.carDetails' | translate"
              (onEdit)="editQuotation()"
              [disableBtn]="disableEditQuotationBtn"
            >
              <ng-container snippet>
                <div class="vec-info">
                  {{ personalInfo?.vehicleNo }}
                  <div class="dot"></div>
                  {{ personalInfo?.vehicle }}
                </div>
                <div class="mt-sm">
                  <ng-container *ngTemplateOutlet="inCollabText"></ng-container>
                </div>
              </ng-container>
              <ng-container hidden>
                <div class="vec-info">
                  {{ personalInfo?.vehicleNo }}
                  <div class="dot"></div>
                  {{ personalInfo?.vehicle }}
                </div>
                <div class="mt-sm">
                  <ng-container *ngTemplateOutlet="inCollabText"></ng-container>
                </div>
                <div class="divider"></div>
                <div class="mt-children-md mt-sm">
                  <app-flex-container
                    [title]="getInsuranceLabelName | translate"
                    [value]="
                      'common.' + personalInfo?.insuranceType | translate
                    "
                  ></app-flex-container>
                  <app-flex-container
                    [title]="getSILabelName | translate"
                    [value]="selectedQuotation?.sumInsured | number : '1.2-2'"
                    [currency]="true"
                  ></app-flex-container>
                  <!-- [PSSR-2072] Sum Insured Range Indicator - Show Range if TypeOfSum = AV and MinAVSI has value -->
                  <app-flex-container
                    *ngIf="
                      selectedQuotation?.typeOfSum === 'AV' &&
                      selectedQuotation?.minAVSI > 0
                    "
                    [title]="'common.minMaxRange' | translate"
                    [value]="
                      'common.minMaxRangeValue'
                        | translate
                          : {
                              currency: 'RM',
                              min:
                                selectedQuotation?.minAVSI | number : '1.2-2',
                              max: selectedQuotation?.maxAVSI | number : '1.2-2'
                            }
                    "
                    [currency]="false"
                  ></app-flex-container>
                  <app-flex-container
                    *ngIf="
                      selectedQuotation?.typeOfSum === 'MV' &&
                      selectedQuotation?.minMVSI > 0
                    "
                    [title]="'common.minMaxRangeMV' | translate"
                    [value]="
                      'common.minMaxRangeValue'
                        | translate
                          : {
                              currency: 'RM',
                              min:
                                selectedQuotation?.minMVSI | number : '1.2-2',
                              max: selectedQuotation?.maxMVSI | number : '1.2-2'
                            }
                    "
                    [currency]="false"
                  ></app-flex-container>
                  <app-flex-container
                    [title]="'common.effectiveDate' | translate"
                    [value]="personalInfo?.effectiveDate | date : 'dd MMM yyyy'"
                  ></app-flex-container>
                  <!-- <app-flex-container
                    [title]="'Excess'"
                    [value]="
                      selectedQuotation?.defaultExcessDiscount
                        | number : '1.2-2'
                    "
                    [currency]="true"
                  ></app-flex-container> -->
                </div>
              </ng-container>
            </app-expandable-card>
            <div
              class="order-summary"
              *ngIf="!(screenSizeService.isMobile$ | async)"
            >
              <app-expandable-card [title]="'common.orderSummary' | translate">
                <ng-container snippet>
                  <ng-container
                    *ngTemplateOutlet="orderSummarySnippet"
                  ></ng-container>
                </ng-container>
                <ng-container hidden>
                  <ng-container *ngTemplateOutlet="orderSummary">
                  </ng-container>
                </ng-container>
                <ng-container share>
                  <ng-container *ngTemplateOutlet="voucherHeader">
                  </ng-container>
                  <!-- <ng-container *ngTemplateOutlet="referralTemplate">
                  </ng-container>
                  <ng-container *ngTemplateOutlet="promoTemplate">
                  </ng-container> -->
                </ng-container>
              </app-expandable-card>
            </div>
          </div>

          <app-mobile-bottombar
            [disabledCondition]="addOnFormGroup.invalid"
            [buttonTemplate]="psMobileNextBtn"
            [voucherTemplate]="psMobilevoucherHeader"
            [discountTemplate]="psMobileDiscountTemplate"
            (onSubmit)="backToStep(2, true)"
            [expandVoucher]="isVoucherExpanded"
            (voucherToggle)="isVoucherExpanded = $event"
            *ngIf="getFinalTotalBeforeVoucher()"
          >
            <ng-container slot="expandedContent">
              <ng-container *ngTemplateOutlet="orderSummary"> </ng-container>
              <!-- <ng-container *ngTemplateOutlet="referralTemplate">
              </ng-container>
              <ng-container *ngTemplateOutlet="promoTemplate"> </ng-container> -->
            </ng-container>
            <ng-container slot="voucherContent">
              <ng-container *ngTemplateOutlet="voucherForm"> </ng-container>
            </ng-container>
          </app-mobile-bottombar>
        </div>
      </form>
    </mat-step>

    <!-- ## Step: Third step -->
    <mat-step state="edit" [stepControl]="infoFormGroup">
      <ng-template matStepLabel>
        {{ "plans.step2" | translate }}
      </ng-template>
      <button mat-button matStepperPrevious class="step-back-btn">
        <mat-icon>arrow_back</mat-icon> {{ "common.back" | translate }}
      </button>

      <div class="personal-details-container">
        <div class="main-container">
          <form class="forms" [formGroup]="infoFormGroup">
            <app-section-title
              title="common.personalDetails"
            ></app-section-title>

            <!-- Name Input -->
            <mat-form-field appearance="outline">
              <mat-label>{{ getNameLabel() | translate }}</mat-label>
              <input matInput autocomplete="name" formControlName="name" />
            </mat-form-field>

            <!-- Nationality Input -->
            <mat-form-field
              appearance="outline"
              *ngIf="idType === idTypeOption.foreigner"
            >
              <mat-label>{{ "common.nationality" | translate }}</mat-label>
              <input matInput formControlName="nationality" />
            </mat-form-field>

            <!-- Identity Input -->
            <ng-container [ngSwitch]="idType">
              <ng-container *ngSwitchCase="idTypeOption.malaysian">
                <mat-form-field appearance="outline">
                  <mat-label>
                    {{ "common.icNoLabel" | translate }}
                  </mat-label>
                  <input matInput formControlName="identityNo" />
                </mat-form-field>
              </ng-container>
              <ng-container *ngSwitchCase="idTypeOption.company">
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "common.businessRegistrationNo" | translate
                  }}</mat-label>
                  <input
                    matInput
                    formControlName="identityNo"
                    autocomplete="off"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "common.oldBusinessRegistrationNo" | translate
                  }}</mat-label>
                  <input
                    matInput
                    formControlName="oldBizRegNo"
                    autocomplete="off"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>{{ "common.TIN" | translate }}</mat-label>
                  <input matInput formControlName="tinNo" autocomplete="off" />
                </mat-form-field>
              </ng-container>
              <ng-container *ngSwitchCase="idTypeOption.foreigner">
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "common.passportLabel" | translate
                  }}</mat-label>
                  <input
                    matInput
                    formControlName="identityNo"
                    autocomplete="off"
                  />
                </mat-form-field>
              </ng-container>
              <ng-container *ngSwitchCase="idTypeOption.police">
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "common.policeOrArmyIcNo" | translate
                  }}</mat-label>
                  <input matInput formControlName="policIdentityNo" />
                </mat-form-field>
              </ng-container>
            </ng-container>

            <!-- Police Identity Input -->
            <ng-container *ngIf="idType === idTypeOption.police">
              <mat-form-field appearance="outline">
                <mat-label>{{ "common.icNoLabel" | translate }}</mat-label>
                <input matInput formControlName="identityNo" />
              </mat-form-field>
            </ng-container>

            <!-- Mobile No. Input -->
            <mat-form-field appearance="outline">
              <mat-label>{{ "common.mobileNo" | translate }}</mat-label>
              <ngx-mat-intl-tel-input
                [enableSearch]="true"
                [preferredCountries]="['my']"
                formControlName="mobileNo"
              >
              </ngx-mat-intl-tel-input>
              <mat-error
                >{{ "common.mobileNo" | translate }}
                {{
                  infoFormGroup.controls.mobileNo.errors
                    | inputError
                    | translate
                }}</mat-error
              >
            </mat-form-field>

            <!-- Email Input -->
            <mat-form-field appearance="outline" class="pb-sm">
              <mat-label>{{ "common.emailAddress" | translate }}</mat-label>
              <input matInput formControlName="email" autocomplete="email" />
              <mat-error
                style="display: block !important"
                [hidden]="!infoFormGroup.controls.email?.errors?.email"
              >
                {{ "error.invalidEmail" | translate }}</mat-error
              >
              <mat-error
                >{{ "common.emailAddress" | translate }}
                {{
                  infoFormGroup.controls.email.errors | inputError | translate
                }}</mat-error
              >
            </mat-form-field>

            <!-- Marital status Input -->
            <section *ngIf="idType !== idTypeOption.company">
              <mat-label>{{ "common.maritalStatus" | translate }}:</mat-label>
              <mat-radio-group
                class="b2c-radio"
                aria-label="Select an option"
                formControlName="maritalStatus"
              >
                <mat-radio-button [value]="maritalStatusOption.single"
                  >{{ "common.Single" | translate }}
                </mat-radio-button>
                <mat-radio-button [value]="maritalStatusOption.married"
                  >{{ "common.Married" | translate }}
                </mat-radio-button>
              </mat-radio-group>
            </section>

            <!-- Gender Input -->
            <section
              class="box-selection mb-md"
              *ngIf="idType !== idTypeOption.company"
            >
              <mat-label>{{ "common.gender" | translate }}</mat-label>
              <mat-radio-group
                class="b2c-radio"
                aria-label="Select an option"
                formControlName="gender"
              >
                <mat-radio-button [value]="genderOption.male"
                  >{{ "common.M" | translate }}
                </mat-radio-button>
                <mat-radio-button [value]="genderOption.female"
                  >{{ "common.F" | translate }}
                </mat-radio-button>
              </mat-radio-group>
            </section>

            <app-section-title
              title="plans.step2Content.residentialAddressTitle"
            ></app-section-title>
            <mat-form-field appearance="outline">
              <mat-label>{{ "common.addressLineOne" | translate }}</mat-label>
              <input matInput formControlName="address1" />
              <mat-error>
                {{ "common.addressLineOne" | translate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ "common.addressLineTwo" | translate }}</mat-label>
              <input matInput formControlName="address2" />
              <mat-error>
                {{ "common.addressLineTwo" | translate }}
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ "common.city" | translate }}</mat-label>
              <input matInput formControlName="city" />
              <mat-error>
                {{ "common.city" | translate }}
              </mat-error>
            </mat-form-field>
            <div class="forms__flex">
              <mat-form-field appearance="outline">
                <mat-label>{{ "common.postcode" | translate }}</mat-label>
                <input matInput disabled [value]="personalInfo?.postcode" />
                <mat-error>
                  {{ "common.postcode" | translate }}
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ "common.state" | translate }}</mat-label>
                <mat-select formControlName="state">
                  <mat-option *ngFor="let item of stateList" [value]="item">{{
                    item
                  }}</mat-option>
                </mat-select>
                <mat-error>
                  {{ "common.state" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <mat-checkbox
              class="mb-md"
              style="margin-top: 14px"
              (change)="deliveryAddressChecked($event)"
              *ngIf="
                addOnFormGroup.value?.isIncludeRoadtax &&
                !isIncludeDigitalRoadtax
              "
            >
              {{ "common.sendToDifferentAddress" | translate }}
            </mat-checkbox>
            <ng-container *ngIf="enableDeliveryAddress">
              <app-section-title
                title="plans.step2Content.deliveryAddressTitle"
              ></app-section-title>
              <mat-form-field appearance="outline">
                <mat-label>{{ "common.addressLineOne" | translate }}</mat-label>
                <input matInput formControlName="deliveryAddress1" />
                <mat-error>
                  {{ "common.addressLineOne" | translate }}
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ "common.addressLineTwo" | translate }}</mat-label>
                <input matInput formControlName="deliveryAddress2" />
                <mat-error>
                  {{ "common.addressLineTwo" | translate }}
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ "common.city" | translate }}</mat-label>
                <input matInput formControlName="deliveryCity" />
                <mat-error>
                  {{ "common.city" | translate }}
                </mat-error>
              </mat-form-field>
              <div class="forms__flex">
                <mat-form-field appearance="outline">
                  <mat-label>{{ "common.postcode" | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="deliveryPostcode"
                    mask="00000"
                  />
                  <mat-error>
                    {{ "common.postcode" | translate }}
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>{{ "common.state" | translate }}</mat-label>
                  <mat-select formControlName="deliveryState">
                    <mat-option *ngFor="let item of stateList" [value]="item">{{
                      item
                    }}</mat-option>
                  </mat-select>
                  <mat-error>
                    {{ "common.state" | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </ng-container>

            <!--
              New Section for Company Cases (currently used by Generali due to the Full Journey integration)
              - TIN and SST Registration No is needed in GetOrder API
              - probably the same when other insurers' is integrated with full journey
            -->
            <ng-container *ngIf="checkIsGeneraliCompanyQuotation()">
              <app-section-title
                title="common.otherDetails"
              ></app-section-title>
              <mat-form-field appearance="outline">
                <mat-label>{{ "common.TIN" | translate }}</mat-label>
                <input
                  matInput
                  formControlName="TIN"
                  (input)="toUpperCase($event, 'TIN')"
                />
                <mat-error
                  *ngIf="infoFormGroup.controls.TIN.hasError('required')"
                >
                  {{ "common.TIN" | translate }}
                  {{
                    infoFormGroup.controls.TIN.errors | inputError | translate
                  }}
                </mat-error>
                <mat-error
                  *ngIf="infoFormGroup.controls.TIN.hasError('pattern')"
                >
                  {{ "error.invalidTINFormat" | translate }}
                </mat-error>
                <mat-error
                  *ngIf="infoFormGroup.controls.TIN.hasError('minlength')"
                >
                  {{ "error.invalidTINMinLength" | translate }}
                </mat-error>
                <mat-error
                  *ngIf="infoFormGroup.controls.TIN.hasError('maxlength')"
                >
                  {{ "error.invalidTINMaxLength" | translate }}
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ "common.SSTRegNo" | translate }}</mat-label>
                <input
                  matInput
                  formControlName="SSTRegNo"
                  (input)="toUpperCase($event, 'SSTRegNo')"
                />
                <mat-error
                  *ngIf="infoFormGroup.controls.SSTRegNo.hasError('pattern')"
                >
                  {{ "error.invalidSSTRegNoFormat" | translate }}
                </mat-error>
              </mat-form-field>
            </ng-container>
          </form>
          <!-- Max Savings -->
          <ng-container
            *ngIf="excessData?.length && stepper?.selectedIndex == 2"
          >
            <app-excess
              [data]="excessData"
              [quotationData]="selectedQuotation"
              [selectedExcess]="selectedExcess"
              (onChangeExcess)="changeExcess($event)"
              *ngIf="isPolicystreetProduct"
            >
            </app-excess>
          </ng-container>
          <div class="btn-group-container">
            <button mat-stroked-button matStepperPrevious>
              {{ "common.back" | translate }}
            </button>
            <button
              mat-flat-button
              matStepperNext
              [disabled]="infoFormGroup.invalid"
              (click)="getPersonalDetailsCardData()"
            >
              {{ "common.continue" | translate }}
            </button>
          </div>
        </div>
        <div class="sidebar-container">
          <mat-card class="insurance-card-container">
            <div class="flex">
              <div class="flex__left">
                <div class="flex__img">
                  <img src="assets/image/ps-logo-flex-column.png" alt="" />
                </div>
                <div class="flex__title">
                  {{
                    "common." +
                      personalInfo?.insuranceType +
                      (isTakaful ? "CarTakaful" : "CarInsurance") | translate
                  }}
                  <div class="mt-xs">
                    <span
                      class="bundle-selected"
                      *ngFor="let item of selectedBundle"
                    >
                      <img
                        src="https://i.ibb.co/8XbtGsw/Ellipse-37.png"
                        alt=""
                        class="pr-xs"
                      />
                      <span class="bold">{{ item?.description }}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="flex__edit-btn">
                <button mat-stroked-button (click)="stepper.selectedIndex = 0">
                  {{ "common.edit" | translate }}
                </button>
              </div>
            </div>
            <div class="divider"></div>
            <ng-container *ngTemplateOutlet="inCollabText"></ng-container>
          </mat-card>
          <div
            class="order-summary"
            *ngIf="!(screenSizeService.isMobile$ | async)"
          >
            <app-expandable-card [title]="'common.orderSummary' | translate">
              <ng-container snippet>
                <ng-container
                  *ngTemplateOutlet="orderSummarySnippet"
                ></ng-container>
              </ng-container>
              <ng-container hidden>
                <ng-container *ngTemplateOutlet="orderSummary"> </ng-container>
              </ng-container>
              <ng-container share>
                <ng-container *ngTemplateOutlet="voucherHeader"> </ng-container>
                <!-- <ng-container *ngTemplateOutlet="referralTemplate">
                </ng-container>
                <ng-container *ngTemplateOutlet="promoTemplate"> </ng-container> -->
              </ng-container>
            </app-expandable-card>
          </div>
        </div>
        <app-mobile-bottombar
          [disabledCondition]="infoFormGroup.invalid"
          [buttonTemplate]="psMobileNextBtn"
          [voucherTemplate]="psMobilevoucherHeader"
          [discountTemplate]="psMobileDiscountTemplate"
          (onSubmit)="backToStep(3)"
          [expandVoucher]="isVoucherExpanded"
          (voucherToggle)="isVoucherExpanded = $event"
          *ngIf="getFinalTotalBeforeVoucher()"
        >
          <ng-container slot="expandedContent">
            <ng-container *ngTemplateOutlet="orderSummary"> </ng-container>
            <!-- <ng-container *ngTemplateOutlet="referralTemplate">
              </ng-container>
              <ng-container *ngTemplateOutlet="promoTemplate"> </ng-container> -->
          </ng-container>
          <ng-container slot="voucherContent">
            <ng-container *ngTemplateOutlet="voucherForm"> </ng-container>
          </ng-container>
        </app-mobile-bottombar>
      </div>
    </mat-step>

    <!-- ##Step: Fourth step -->
    <mat-step
      state="edit"
      [state]="agreementFrmGroup.valid ? 'edit' : 'close'"
      [stepControl]="agreementFrmGroup"
    >
      <form [formGroup]="agreementFrmGroup">
        <ng-template matStepLabel>
          {{ "plans.step3" | translate }}
        </ng-template>
        <button mat-button matStepperPrevious class="step-back-btn">
          <mat-icon>arrow_back</mat-icon> {{ "common.back" | translate }}
        </button>

        <div class="summary-page-container">
          <div class="main-container">
            <ng-container *ngIf="ctaBanner.length != 0">
              <div
                *ngFor="let banner of ctaBanner"
                class="cta-banner summary-page"
              >
                <img
                  [src]="banner.src"
                  [alt]="banner.alt"
                  *ngIf="translate.currentLang == banner.lang && banner.show"
                />
              </div>
            </ng-container>
            <app-section-title
              title="plans.step3Content.summaryTitle"
              desc="plans.step3Content.summaryDesc"
            ></app-section-title>
            <div class="summary-card-container">
              <!-- Protection details -->
              <mat-card>
                <div class="protection-details-card">
                  <div class="header-container">
                    <div>{{ "common.protectionDetails" | translate }}</div>
                    <button
                      mat-stroked-button
                      color="primary"
                      class="edit-btn"
                      (click)="stepper.selectedIndex = 0"
                    >
                      {{ "common.edit" | translate }}
                    </button>
                  </div>

                  <div class="content">
                    <div class="content__img">
                      <img src="assets/image/ps-logo-flex-column.png" alt="" />
                    </div>
                    <div class="content__title">
                      {{
                        "common." +
                          personalInfo?.insuranceType +
                          (isTakaful ? "CarTakaful" : "CarInsurance")
                          | translate
                      }}
                      <div class="desc pt-xs">
                        {{ "plans.forYourCar" | translate }}
                        <strong>{{ personalInfo?.vehicleNo }}</strong>
                      </div>
                    </div>
                  </div>
                  <div class="divider"></div>
                  <div class="mt-children-md">
                    <div class="flex-container" *ngIf="selectedBundle.length">
                      <div class="flex-container__title">
                        {{ "plans.step2Content.protectionType" | translate }}
                      </div>
                      <div class="flex-container__value">
                        <div
                          *ngFor="let item of selectedBundle"
                          class="flex-container__bold"
                        >
                          {{ item?.description }}
                        </div>
                      </div>
                    </div>

                    <app-flex-container
                      [title]="getSILabelName | translate"
                      [value]="selectedQuotation?.sumInsured | number : '1.2-2'"
                      [currency]="true"
                    ></app-flex-container>
                    <app-flex-container
                      [title]="'common.effectiveDate' | translate"
                      [value]="
                        personalInfo?.effectiveDate | date : 'dd MMM yyyy'
                      "
                    ></app-flex-container>
                  </div>
                  <div class="divider"></div>
                  <ng-container *ngTemplateOutlet="inCollabText"></ng-container>
                </div>
              </mat-card>
              <!-- Car details -->
              <app-summary-card
                [title]="'common.carDetails' | translate"
                [editable]="true"
                (onEdit)="editQuotation()"
                [disableBtn]="disableEditQuotationBtn"
              >
                <app-flex-container
                  [title]="'common.carNumber' | translate"
                  [value]="personalInfo?.vehicleNo"
                ></app-flex-container>
                <app-flex-container
                  [title]="'common.carModel' | translate"
                  [value]="personalInfo?.vehicle"
                ></app-flex-container>
              </app-summary-card>
              <!-- Add ons -->
              <ng-container
                *ngIf="
                  selectedBundleAddOn.length ||
                  selectedAddOn.length ||
                  includedAddOn.length ||
                  selectedMotorMembership.length ||
                  isCarPlusChecked
                "
              >
                <app-summary-card
                  [title]="'addOn.addOns' | translate"
                  [editable]="true"
                  (onEdit)="backToStep(0)"
                >
                  <ng-content
                    *ngTemplateOutlet="selectedMotorMembershipList"
                  ></ng-content>
                  <ng-content *ngTemplateOutlet="roadTaxAddOn"></ng-content>
                  <ng-content *ngTemplateOutlet="addOnList"></ng-content>
                  <ng-content *ngTemplateOutlet="psxtraAddOnList"></ng-content>
                </app-summary-card>
              </ng-container>
              <!-- Personal details -->
              <app-summary-card [title]="'common.personalDetails' | translate">
                <ng-container
                  *ngTemplateOutlet="personalDetailsCard"
                ></ng-container>
              </app-summary-card>
              <!-- Residential address -->
              <app-summary-card
                [title]="
                  'plans.step2Content.residentialAddressTitle' | translate
                "
                [editable]="true"
                (onEdit)="backToStep(1)"
              >
                <app-flex-container
                  [title]="'common.addressLineOne' | translate"
                  [value]="infoFormGroup.value.address1"
                ></app-flex-container>
                <app-flex-container
                  [title]="'common.addressLineTwo' | translate"
                  [value]="infoFormGroup.value.address2"
                ></app-flex-container>
                <app-flex-container
                  [title]="'common.city' | translate"
                  [value]="infoFormGroup.value.city"
                ></app-flex-container>
                <app-flex-container
                  [title]="'common.postcode' | translate"
                  [value]="personalInfo?.postcode"
                ></app-flex-container>
                <app-flex-container
                  [title]="'common.state' | translate"
                  [value]="infoFormGroup.value.state"
                ></app-flex-container>
              </app-summary-card>
              <!-- Delivery address -->
              <ng-container *ngIf="enableDeliveryAddress">
                <app-summary-card
                  [title]="
                    'plans.step2Content.deliveryAddressTitle' | translate
                  "
                  [editable]="true"
                  (onEdit)="backToStep(1)"
                >
                  <app-flex-container
                    [title]="'common.addressLineOne' | translate"
                    [value]="infoFormGroup.value.deliveryAddress1"
                  ></app-flex-container>
                  <app-flex-container
                    [title]="'common.addressLineTwo' | translate"
                    [value]="infoFormGroup.value.deliveryAddress2"
                  ></app-flex-container>
                  <app-flex-container
                    [title]="'common.city' | translate"
                    [value]="infoFormGroup.value.deliveryCity"
                  ></app-flex-container>
                  <app-flex-container
                    [title]="'common.postcode' | translate"
                    [value]="infoFormGroup.value.deliveryPostcode"
                  ></app-flex-container>
                  <app-flex-container
                    [title]="'common.state' | translate"
                    [value]="infoFormGroup.value.deliveryState"
                  ></app-flex-container>
                </app-summary-card>
              </ng-container>

              <app-order-summary-note
                *ngIf="
                  selectedQuotation?.name &&
                  selectedQuotation.name === 'Generali'
                "
                [text]="'comparison.orderCompulsoryExcess' | translate"
              >
              </app-order-summary-note>

              <!-- Other Details -->
              <app-summary-card
                *ngIf="checkIsGeneraliCompanyQuotation()"
                [title]="'common.otherDetails' | translate"
                [editable]="true"
                (onEdit)="backToStep(1)"
              >
                <app-flex-container
                  [title]="'common.TIN' | translate"
                  [value]="infoFormGroup.value.TIN"
                ></app-flex-container>
                <app-flex-container
                  [title]="'common.SSTRegNo' | translate"
                  [value]="infoFormGroup.value.SSTRegNo"
                ></app-flex-container>
              </app-summary-card>

              <!-- Vehicle Photo Upload -->
              <div class="vehicle-photo-upload">
                <div class="header">
                  <mat-checkbox (change)="toggleVehiclePhoto($event)">
                    <b>{{
                      "plans.step3Content.uploadVehiclePhotoHeaderTitle"
                        | translate
                    }}</b>
                    <small
                      ><i>{{
                        "plans.step3Content.uploadVehiclePhotoHeaderTitleSmall"
                          | translate
                      }}</i></small
                    >
                  </mat-checkbox>

                  <mat-icon
                    class="tooltip-icon"
                    [matMenuTriggerFor]="vehiclePhotoTooltip"
                    #vehiclePhotoTrigger="matMenuTrigger"
                    (mouseenter)="vehiclePhotoTrigger.openMenu()"
                  >
                    info
                  </mat-icon>
                  <mat-menu
                    #vehiclePhotoTooltip="matMenu"
                    [overlapTrigger]="false"
                    class="tooltip-popover"
                  >
                    <span
                      fxLayout="column"
                      (mouseleave)="vehiclePhotoTrigger.closeMenu()"
                    >
                      {{
                        "plans.step3Content.uploadVehiclePhotoHeaderTooltip"
                          | translate
                      }}
                      <img
                        src="https://storage.googleapis.com/dev-ps-asset/images/vehicle_photo_upload_example.png"
                      />
                    </span>
                  </mat-menu>

                  <div fxLayout="row">
                    {{
                      "plans.step3Content.uploadVehiclePhotoHeaderDesc"
                        | translate
                    }}
                  </div>
                </div>

                <div *ngIf="showUploadMenu" class="content" fxLayout="column">
                  <div fxLayout="row">
                    {{
                      "plans.step3Content.uploadVehiclePhotoContentTitle"
                        | translate
                    }}
                  </div>

                  <div
                    class="content-img-desc"
                    fxLayout="row"
                    fxLayoutAlign="space-between"
                  >
                    <span>
                      {{
                        "plans.step3Content.uploadVehiclePhotoContentImgDesc1"
                          | translate
                            : {
                                fileExtensions:
                                  vehiclePhotoValidation.fileExtensionToDisplay
                              }
                      }}
                    </span>
                    <span>
                      {{
                        "plans.step3Content.uploadVehiclePhotoContentImgDesc2"
                          | translate
                            : { fileSize: vehiclePhotoValidation.fileSize }
                      }}
                    </span>
                  </div>

                  <div
                    class="content-img-upload"
                    *ngFor="let item of uploadVehiclePhoto"
                  >
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                      <div
                        class="img-desc"
                        fxLayout="row"
                        fxLayoutAlign="center center"
                      >
                        <img
                          src="assets/icons/image-icon.svg"
                          alt="{{ item.name }}"
                        />
                        <span>{{ item.name | translate }}</span>
                      </div>

                      <div fxLayout="row">
                        <input
                          type="file"
                          accept="{{ vehiclePhotoValidation.fileExtension }}"
                          (change)="uploadFile($event, item.name)"
                          id="{{ item.name }}"
                          name="{{ item.name }}"
                          style="display: none"
                        />
                        <label for="{{ item.name }}" class="upload-label-btn">
                          <mat-icon>add_circle</mat-icon
                          >{{ "common.upload" | translate }}
                        </label>
                      </div>
                    </div>

                    <div
                      *ngIf="item.selectedFile != null"
                      class="color-link"
                      fxLayout="row"
                    >
                      {{ item.selectedFile.name }}
                      <button mat-icon-button (click)="deleteFile(item.name)">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="mobile-order-summary"
              *ngIf="screenSizeService.isMobile$ | async"
            >
              <ng-container *ngTemplateOutlet="paymentOption"> </ng-container>
              <!-- <div class="mt-lg">
                <app-section-title
                  [title]="'common.orderSummary' | translate"
                ></app-section-title>
              </div> -->
              <!-- <ng-container *ngTemplateOutlet="orderSummary"></ng-container> -->
              <ng-container *ngTemplateOutlet="voucherHeader"></ng-container>
              <!-- <ng-container *ngTemplateOutlet="referralTemplate">
              </ng-container>
              <ng-container *ngTemplateOutlet="promoTemplate"> </ng-container> -->
              <!-- <ng-container
                *ngTemplateOutlet="
                  multiCheckbox;
                  context: { form: agreementFrmGroup }
                "
              ></ng-container> -->
            </div>
          </div>
          <div class="sidebar-container">
            <div
              class="order-summary"
              *ngIf="!(screenSizeService.isMobile$ | async)"
            >
              <app-expandable-card [title]="'common.orderSummary' | translate">
                <ng-container snippet>
                  <ng-container
                    *ngTemplateOutlet="orderSummarySnippet"
                  ></ng-container>
                </ng-container>
                <ng-container hidden>
                  <ng-container *ngTemplateOutlet="orderSummary"></ng-container>
                </ng-container>
                <ng-container share>
                  <ng-container
                    *ngTemplateOutlet="voucherHeader"
                  ></ng-container>
                  <!-- <ng-container *ngTemplateOutlet="referralTemplate">
                  </ng-container>
                  <ng-container
                    *ngTemplateOutlet="promoTemplate"
                  ></ng-container> -->
                  <ng-container
                    *ngTemplateOutlet="paymentOption"
                  ></ng-container>
                  <ng-container
                    *ngTemplateOutlet="
                      multiCheckbox;
                      context: { form: agreementFrmGroup }
                    "
                  ></ng-container>
                </ng-container>
              </app-expandable-card>
            </div>
          </div>
          <div class="sticky-total-amt">
            <app-mobile-total-amount
              [totalAmount]="getFinalTotal()"
              [label]="getPaymentDurationLabel()"
            ></app-mobile-total-amount>
          </div>
          <!-- payment submit mobile here -->
          <app-mobile-bottombar
            [disabledCondition]="paymentFormGroup?.invalid"
            [disabledContactPS]="true"
            [isRetryPayment]="isRetryPayment"
            [buttonTemplate]="psMobileNextBtn"
            (onReviewButtonClick)="showAcknowledgementDialog()"
            [voucherTemplate]="psMobilevoucherHeader"
            [discountTemplate]="psMobileDiscountTemplate"
            (onSubmit)="submit()"
            [expandVoucher]="isVoucherExpanded"
            (voucherToggle)="isVoucherExpanded = $event"
            *ngIf="getFinalTotal()"
          >
            <ng-container slot="expandedContent">
              <ng-container *ngTemplateOutlet="orderSummary"> </ng-container>
              <!-- <ng-container *ngTemplateOutlet="referralTemplate">
              </ng-container>
              <ng-container *ngTemplateOutlet="promoTemplate"> </ng-container> -->
            </ng-container>
            <ng-container slot="voucherContent">
              <ng-container *ngTemplateOutlet="voucherForm"> </ng-container>
            </ng-container>
          </app-mobile-bottombar>
        </div>
      </form>
    </mat-step>

    <!-- #Step: Fifth step (for display only) -->
    <mat-step state="pay" [aria-labelledby]="'disabled'">
      <ng-template matStepLabel>
        {{ "plans.step4" | translate }}
      </ng-template>
    </mat-step>
  </mat-stepper>
</div>
<div class="footer-bnm-bg" *ngIf="stepper?.selectedIndex !== 0">
  {{ "footer.pidm1" | translate }}
  <span class="underlined-blue" (click)="openPIDMLink(translate.currentLang)"
    >PIDM</span
  >
  {{ "footer.pidm2" | translate }}
  <span
    class="underlined-blue"
    (click)="openBrochureLink(translate.currentLang)"
    >{{ "footer.pidm3" | translate }}</span
  >
  {{
    "footer.pidm4"
      | translate
        : {
            insurer: insurerFullName
          }
  }}
  <span class="underlined-blue" (click)="openPIDMLink(translate.currentLang)"
    >www.pidm.gov.my</span
  >).

  <hr class="mt-sm mb-sm" />

  {{ "footer.BNM1" | translate : { insurer: insurerFullName } }}<br /><br />
  <span>
    {{
      "comparison.orderSummaryNote"
        | translate : { commission: getPSComissionPrice() | number : "1.2-2" }
    }}. {{ "footer.BNM2" | translate : { insurer: insurerFullName } }}
  </span>
</div>

<!-- ## Template: all the templates starts here -->
<ng-template matStepperIcon="edit">
  <mat-icon>edit</mat-icon>
</ng-template>

<ng-template matStepperIcon="close">
  <mat-icon>close</mat-icon>
</ng-template>

<ng-template matStepperIcon="pay">
  <mat-icon>payment</mat-icon>
</ng-template>

<ng-template #personalDetailsCard>
  <ng-container *ngFor="let x of personalDetailsCardData">
    <ng-container *ngIf="x.translateValue">
      <app-flex-container
        [title]="x.title | translate"
        [value]="x.value | translate"
      ></app-flex-container>
    </ng-container>
    <ng-container *ngIf="!x.translateValue">
      <app-flex-container
        [title]="x.title | translate"
        [value]="x.value"
      ></app-flex-container>
    </ng-container>
  </ng-container>
</ng-template>

<!-- <ng-templete #></ng-templete> -->

<ng-template #voucherForm>
  <div style="height: 60vh; width: 100%">
    <div class="promo-error" *ngIf="promoError">
      {{
        "common." + promoError
          | translate
            : {
                promoMinAmt: promoMinAmount | number : "1.2-2",
                promoMaxAmt: promoMaxAmount | number : "1.2-2"
              }
      }}
    </div>
    <app-voucher-dialog
      *ngIf="personalInfo?.vehicleNo"
      [plateNumber]="personalInfo.vehicleNo"
      [openVoucher]="true"
      [totalAmountMobile]="getFinalTotalBeforeVoucher()"
      [quoteId]="id"
      [identityNumber]="personalInfo.identityNo"
      [voucherListCode]="voucherListCode"
      (onClose)="toggleVoucher()"
      (voucherCodeList)="handleVoucherMobile($event)"
    ></app-voucher-dialog>
  </div>
</ng-template>

<ng-template #orderSummary2>
  <div class="order-summary-container mt-children-md">
    <ng-container *ngTemplateOutlet="psMobileNextBtn"></ng-container>
  </div>
</ng-template>

<ng-template #orderSummary>
  <div class="order-summary-container mt-children-md">
    <!-- <ng-container *ngTemplateOutlet="psMobileNextBtn"></ng-container> -->

    <span class="title">{{ "common.orderSummary" | translate }}</span>

    <app-flex-container
      [title]="getSILabelName | translate"
      [value]="selectedQuotation?.sumInsured | number : '1.2-2'"
      [currency]="true"
    ></app-flex-container>
    <app-flex-container
      [title]="getBasePremLabelName | translate"
      [value]="selectedQuotation?.basePremium | number : '1.2-2'"
      [currency]="true"
    ></app-flex-container>
    <ng-container *ngIf="selectedExcess && selectedExcess?.price >= 0">
      <app-flex-container
        [title]="'common.additionalDiscount' | translate"
        [titleBelow]="
          '(' +
          ('excess.' + selectedExcess?.name + '.contentTitle' | translate) +
          ')'
        "
        [value]="selectedExcess?.price | number : '1.2-2'"
        type="discount"
        [currency]="true"
      ></app-flex-container>
    </ng-container>
    <app-flex-container
      [title]="
        ('common.noClaimDiscount' | translate) +
        '(' +
        (personalInfo?.ncd * 100 | number : '1.0-2') +
        '%)'
      "
      [value]="getNcdPrice() | number : '1.2-2'"
      type="discount"
      style="color: #214ed4"
    ></app-flex-container>
    <div class="divider"></div>
    <app-flex-container
      [title]="getBasePremLabelName | translate"
      [value]="getTotalBasePremium() | number : '1.2-2'"
      type="total"
      [currency]="true"
    ></app-flex-container>
    <!-- Special package -->
    <div class="tag" *ngIf="selectedBundle.length">
      {{ "plans.specialPackage" | translate }}
    </div>
    <ng-container *ngIf="selectedBundle.length">
      <ng-container *ngFor="let item of selectedBundle">
        <app-flex-container
          [title]="item?.description"
          [value]="item?.evaluate | number : '1.2-2'"
          [currency]="true"
        ></app-flex-container>
      </ng-container>
    </ng-container>
    <!-- End Special package -->
    <!-- Add ons -->
    <div
      class="tag"
      *ngIf="
        selectedBundleAddOn.length ||
        selectedAddOnToDisplay.length ||
        includedAddOn.length ||
        isCarPlusChecked
      "
    >
      {{ "addOn.addOns" | translate }}
    </div>
    <ng-content *ngTemplateOutlet="addOnList"></ng-content>
    <!-- End Add ons -->
    <div class="divider"></div>

    <app-flex-container
      [title]="getTotalGrossPremLabelName | translate"
      [value]="getTotalGrossPremium() | number : '1.2-2'"
      type="total"
      [currency]="true"
    ></app-flex-container>
    <app-flex-container
      [title]="
        ('common.serviceTax' | translate) +
        ' (' +
        (selectedQuotation?.taxRate * 100 | number : '1.0-2') +
        '%)'
      "
      [value]="getServiceTax() | number : '1.2-2'"
      [currency]="true"
      type="normal"
    ></app-flex-container>
    <app-flex-container
      *ngIf="selectedQuotation?.name && selectedQuotation.name === 'Generali'"
      [title]="'common.agencyCommission' | translate"
      [value]="getPSComissionPrice() | number : '1.2-2'"
      [currency]="true"
      type="normal"
    ></app-flex-container>
    <app-flex-container
      [title]="'common.stampDuty' | translate"
      [value]="selectedQuotation?.stampDutyPrice | number : '1.2-2'"
      [currency]="true"
      type="normal"
    ></app-flex-container>
    <div class="divider"></div>
    <app-flex-container
      [title]="getTotalNetPremLabelName | translate"
      [value]="getTotalNetPremium() | number : '1.2-2'"
      type="total"
      [currency]="true"
    ></app-flex-container>
    <ng-container *ngIf="this.selectedQuotation?.platformDiscountRate">
      <app-flex-container
        [title]="'common.platformOffer' | translate"
        [value]="getPlatformDiscountRate() | number : '1.2-2'"
        type="discount"
        [currency]="true"
      ></app-flex-container>
    </ng-container>
    <ng-container *ngIf="this.selectedQuotation?.rebate">
      <app-flex-container
        [title]="'common.rebate' | translate"
        [value]="this.selectedQuotation?.rebate | number : '1.2-2'"
        type="discount"
        [currency]="true"
      ></app-flex-container>
    </ng-container>
    <ng-container *ngIf="addOnFormGroup.value?.isIncludeRoadtax">
      <app-flex-container
        [title]="'addOn.roadTaxRenewal' | translate"
        [value]="
          (hasSelectedMotorMembership
            ? getDrivePlusRoadtaxPrice()
            : updateOriginalRoadtaxPrice
          ) | number : '1.2-2'
        "
        [currency]="true"
        type="normal"
        [memberDiscount]="
          hasSelectedMotorMembership
            ? true
            : false
        "
      ></app-flex-container>
      <ng-container *ngIf="isIncludeDigitalRoadtax">
        <app-flex-container
          [title]="'digitalRoadTaxFee' | translate"
          [value]="0 | number : '1.2-2'"
          type="normal"
          [currency]="true"
          [memberDiscount]="
            hasSelectedMotorMembership
              ? true
              : false
          "
        ></app-flex-container>
      </ng-container>
      <ng-container *ngIf="!isIncludeDigitalRoadtax">
        <app-flex-container
          [title]="'addOn.roadTaxDelivery' | translate"
          type="normal"
          [value]="
            (hasSelectedMotorMembership
              ? membershipRTHandlingFee
              : personalInfo.roadTaxDeliveryPrice
            ) | number : '1.2-2'
          "
          [currency]="true"
          [memberDiscount]="
            hasSelectedMotorMembership
              ? true
              : false
          "
        ></app-flex-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="selectedNonSSTAddOnToDisplay.length">
      <ng-container *ngFor="let item of selectedNonSSTAddOnToDisplay">
        <app-flex-container
          [title]="'addOn.' + item.customCode | translate"
          [value]="getPrice(item, this.numberOfLltpSeats) | number : '1.2-2'"
          [currency]="true"
        >
        </app-flex-container>
      </ng-container>
    </ng-container>
    <div class="divider"></div>

    <div
      *ngIf="
        selectedPsxtraAddOnToDisplay.length || selectedMotorMembership.length
      "
    >
      <div style="margin-bottom: 18px"></div>
      <app-psxtra-tag></app-psxtra-tag>
      <ng-content *ngTemplateOutlet="selectedMotorMembershipList"></ng-content>
      <ng-content *ngTemplateOutlet="psxtraAddOnList"></ng-content>
      <ng-content *ngTemplateOutlet="selectedAtomePayment"></ng-content>
      <ng-content *ngTemplateOutlet="selectedEppPayment"></ng-content>
      <div class="divider"></div>
    </div>

    <app-flex-container
      [title]="'common.totalCharges' | translate"
      [value]="getTotalCharge() | number : '1.2-2'"
      type="total"
      [currency]="true"
    ></app-flex-container>

    <ng-container *ngIf="promo">
      <app-flex-container
        [title]="promo.name"
        [value]="getTotalPromo() | number : '1.2-2'"
        type="discount"
        [currency]="true"
      ></app-flex-container>
    </ng-container>

    <ng-container *ngIf="cash">
      <app-flex-container
        [title]="cash.name"
        [value]="getTotalCash() | number : '1.2-2'"
        type="discount"
        [currency]="true"
      ></app-flex-container>
    </ng-container>

    <ng-container *ngIf="promoGamification">
      <app-flex-container
        [title]="promoGamification.name"
        [value]="getTotalPromoGamification() | number : '1.2-2'"
        type="discount"
        [currency]="true"
      ></app-flex-container>
    </ng-container>

    <ng-container *ngIf="totalBasePremiumDiscountCampaignAmt">
      <app-flex-container
        [title]="
          'common.OffBasePremiumAfterNCD'
            | translate
              : {
                  discountPercentage: totalBasePremiumDiscountCampaignPct
                }
        "
        [value]="getTotalBasePremiumDiscountCampaignAmt() | number : '1.2-2'"
        type="discount"
        [currency]="true"
      ></app-flex-container>
    </ng-container>

    <ng-container *ngIf="discountCampaignAmt">
      <app-flex-container
        [title]="'common.CampaignDiscount' | translate"
        [value]="getDiscountCampaignAmt() | number : '1.2-2'"
        type="discount"
        [currency]="true"
      ></app-flex-container>
    </ng-container>

    <app-flex-container
      *ngIf="memberRenewalDiscountPrice"
      [title]="'plans.motorMembership.DrivePlusRenewalDisc' | translate"
      [value]="memberRenewalDiscountPrice | number : '1.2-2'"
      type="discount"
    ></app-flex-container>

    <app-flex-container
      [title]="'common.serviceFee' | translate"
      [value]="getServiceFee() | number : '1.2-2'"
      type="normal"
      [currency]="true"
    ></app-flex-container>

    <app-flex-container
      [title]="'common.bankInstalmentCharges' | translate"
      [value]="getBankInstalmentCharges() | number : '1.2-2'"
      *ngIf="showBankInstallmentCharges"
      [currency]="true"
      [type]="getBankInstalmentCharges() == 0 ? 'zeroInstalment' : 'normal'"
    >
    </app-flex-container>

    <app-flex-container
      *ngIf="isPaymentTypeBNPL"
      [title]="'common.bnplCharges' | translate"
      [value]="getBNPLCharges() | number : '1.2-2'"
      [currency]="true"
      [type]="getBNPLCharges() == 0 ? 'bnplSubsidized' : 'normal'"
    >
    </app-flex-container>

    <div style="margin-top: 16px"></div>

    <div class="divider"></div>
    <div class="total-amt">
      <div class="title">{{ "common.totalAmount" | translate }}</div>
      <div class="value">RM {{ getFinalTotal() | number : "1.2-2" }}</div>
    </div>
    <div
      class="order-summary-container__note"
      *ngIf="getPaymentDurationLabel()"
      [innerHTML]="getPaymentDurationLabel()"
    ></div>
    <!-- <div class="divider"></div> -->
  </div>
</ng-template>

<ng-template #orderSummarySnippet>
  <div class="order-summary-container">
    <div class="total-amt">
      <div class="title">{{ "common.totalAmount" | translate }}</div>
      <div class="value">RM {{ getFinalTotal() | number : "1.2-2" }}</div>
    </div>
    <div
      class="order-summary-container__note"
      *ngIf="getPaymentDurationLabel()"
      [innerHTML]="getPaymentDurationLabel()"
    ></div>
    <app-order-summary-note
      [text]="
        'comparison.orderSummaryNote'
          | translate : { commission: getPSComissionPrice() | number : '1.2-2' }
      "
    ></app-order-summary-note>
    <div class="divider"></div>
  </div>
</ng-template>

<ng-template #addOnList>
  <ng-container *ngIf="isCarPlusChecked">
    <app-flex-container
      [title]="insurerCarPlusPackage?.title | translate"
      [value]="getPrice(selectedAvailableInsurerCarPlus) | number : '1.2-2'"
      [currency]="true"
    ></app-flex-container>
  </ng-container>
  <ng-container *ngIf="selectedBundleAddOn.length">
    <ng-container *ngFor="let item of selectedBundleAddOn">
      <app-flex-container
        [title]="'plans.bundleAddOns.' + item.code | translate"
        [value]="item?.evaluate | number : '1.2-2'"
        [currency]="true"
      ></app-flex-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="includedAddOn.length">
    <ng-container *ngFor="let item of includedAddOn">
      <app-flex-container
        [title]="'addOn.' + item.code | translate"
        [value]="item?.evaluate | number : '1.2-2'"
        [currency]="true"
      ></app-flex-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="selectedAddOnToDisplay.length">
    <ng-container *ngFor="let item of selectedAddOnToDisplay">
      <ng-container [ngSwitch]="item.code">
        <ng-container *ngSwitchCase="'Windshield'">
          <app-flex-container
            [title]="'addOn.' + item.displayCode | translate"
            [value]="
              getPrice(item, addOnFormGroup.value.windshield) | number : '1.2-2'
            "
            [currency]="true"
          ></app-flex-container>
        </ng-container>
        <ng-container *ngSwitchCase="'AdditionalDrivers'">
          <app-flex-container
            [title]="'addOn.' + item.code | translate"
            [value]="
              getPrice(item, getDriversFormArray()?.controls.length)
                | number : '1.2-2'
            "
            [currency]="true"
          ></app-flex-container>
        </ng-container>
        <ng-container *ngSwitchCase="'LLTP'">
          <app-flex-container
            [title]="'addOn.' + item.displayCode | translate"
            [value]="
              getPrice(item, addOnFormGroup.value.lltpSeats) | number : '1.2-2'
            "
            [currency]="true"
          ></app-flex-container>
        </ng-container>
        <ng-container *ngSwitchCase="'MERW'">
          <app-flex-container
            [title]="'addOn.' + item.code | translate"
            [value]="getPrice(item) | number : '1.2-2'"
            [currency]="true"
          ></app-flex-container>
        </ng-container>
        <ng-container *ngSwitchCase="'UnlimitedDrivers'">
          <div
            *ngIf="
              selectedQuotation.code == 'Zurich' ||
                selectedQuotation.code == 'Zurich_Takaful';
              else useEvalCalculation
            "
          >
            <app-flex-container
              [title]="'addOn.UnlimitedDriversZurich' | translate"
              [value]="getPrice(item) | number : '1.2-2'"
              [currency]="true"
            ></app-flex-container>
          </div>
          <ng-template #useEvalCalculation>
            <app-flex-container
              [title]="'addOn.UnlimitedDrivers' | translate"
              [value]="getPrice(item, item.evaluate) | number : '1.2-2'"
              [currency]="true"
            ></app-flex-container>
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'GCKT'">
          <app-flex-container
            [title]="'addOn.' + item.displayCode | translate"
            [value]="
              getPrice(item, addOnFormGroup.value.gckt) | number : '1.2-2'
            "
            [currency]="true"
          ></app-flex-container>
        </ng-container>
        <ng-container *ngSwitchCase="'VA'">
          <app-flex-container
            [title]="'addOn.' + item.displayCode | translate"
            [value]="getPrice(item, addOnFormGroup.value.va) | number : '1.2-2'"
            [currency]="true"
          ></app-flex-container>
        </ng-container>
        <ng-container *ngSwitchCase="'PA'">
          <app-flex-container
            [title]="
              'addOn.' +
              item.displayCode +
              (selectedQuotation.code == 'Zurich' || selectedQuotation.code == 'Zurich_Takaful' ? '_Zurich' : '')
              | translate
            "
            [value]="
              getPrice(item, addOnFormGroup.value.lltpSeats) | number : '1.2-2'
            "
            [currency]="true"
          ></app-flex-container>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <app-flex-container
            [title]="'addOn.' + item.displayCode | translate"
            [value]="getPrice(item) | number : '1.2-2'"
            [currency]="true"
          ></app-flex-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #selectedMotorMembershipList>
  <ng-container *ngIf="selectedMotorMembership.length">
    <ng-container *ngFor="let item of selectedMotorMembership">
      <app-flex-container
        [title]="'plans.motorMembership.' + item.code | translate"
        [value]="getPrice(item) | number : '1.2-2'"
        [currency]="true"
        [drivePlusMembership]="item?.code"
      ></app-flex-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #roadTaxAddOn>
  <ng-container *ngIf="addOnFormGroup.value?.isIncludeRoadtax">
    <app-flex-container
      [title]="'addOn.roadTaxRenewal' | translate"
      [value]="
        (hasSelectedMotorMembership
          ? getDrivePlusRoadtaxPrice()
          : updateOriginalRoadtaxPrice
        ) | number : '1.2-2'
      "
      [currency]="true"
      type="normal"
      [memberDiscount]="
        hasSelectedMotorMembership
          ? true
          : false
      "
    ></app-flex-container>

    <ng-container *ngIf="isIncludeDigitalRoadtax">
      <app-flex-container
        [title]="'digitalRoadTaxFee' | translate"
        [value]="0 | number : '1.2-2'"
        type="normal"
        [currency]="true"
        [memberDiscount]="
          hasSelectedMotorMembership
            ? true
            : false
        "
      ></app-flex-container>
    </ng-container>

    <ng-container *ngIf="!isIncludeDigitalRoadtax">
      <app-flex-container
        [title]="'addOn.roadTaxDelivery' | translate"
        type="normal"
        [value]="
          (hasSelectedMotorMembership
            ? membershipRTHandlingFee
            : personalInfo.roadTaxDeliveryPrice
          ) | number : '1.2-2'
        "
        [currency]="true"
        [memberDiscount]="
          hasSelectedMotorMembership
            ? true
            : false
        "
      ></app-flex-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #psxtraAddOnList>
  <ng-container *ngIf="selectedPsxtraAddOnToDisplay.length">
    <ng-container *ngFor="let item of selectedPsxtraAddOnToDisplay">
      <app-flex-container
        [title]="'addOn.' + item.code | translate"
        [value]="getPrice(item) | number : '1.2-2'"
        [currency]="true"
      ></app-flex-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #selectedAtomePayment>
  <ng-container
    *ngIf="
      hasSelectedMotorMembership &&
      isPaymentTypeBNPL &&
      isPaymentProviderAtome
    "
  >
    <ng-container>
      <app-flex-container
        [title]="'plans.atomeDiscount' | translate"
        [value]="getAtomeDiscount() | number : '1.2-2'"
        [currency]="true"
        type="discount"
      ></app-flex-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #selectedEppPayment>
  <ng-container
    *ngIf="
      hasSelectedMotorMembership &&
      isPaymentTypeEPP &&
      membershipEppDiscount
    "
  >
    <ng-container>
      <app-flex-container
        [title]="'plans.eppDiscount' | translate"
        [value]="getEppDiscount() | number : '1.2-2'"
        [currency]="true"
        type="discount"
      ></app-flex-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #voucherHeader>
  <div style="margin-top: 10px" (click)="$event.stopPropagation()">
    <div class="voucher">
      <div class="voucher_container" (click)="voucherInput()">
        <div class="voucher_block">
          <div style="width: 35px; height: 32px; padding: 1px 1px 1px 1pxpx">
            <mat-icon>local_activity</mat-icon>
          </div>
          <div>{{ "voucher.applyVoucher" | translate }}</div>
        </div>

        <div style="display: flex">
          <span *ngIf="numberOfVoucher > 0"
            >{{ numberOfVoucher }} {{ "voucher.applied" | translate }}</span
          >
        </div>

        <button type="button" mat-icon-button matSuffix>
          <mat-icon class="color-secondary">chevron_right</mat-icon>
        </button>
      </div>
    </div>

    <ng-container>
      <app-order-summary-note
        [text]="
          'comparison.orderSummaryNoteDisclaimerWithoutServiceFee' | translate
        "
      ></app-order-summary-note>
    </ng-container>
  </div>
</ng-template>

<ng-template #promoTemplate>
  <ng-container>
    <div class="promo-input pt-sm" (click)="$event.stopPropagation()">
      <div class="flex">
        <mat-form-field appearance="outline">
          <input
            matInput
            [placeholder]="'common.enterPromoCode' | translate"
            [(ngModel)]="promoCode"
            autocomplete="off"
            (click)="$event.stopPropagation()"
            [ngModelOptions]="{ standalone: true }"
          />
          <div class="floating-btn">
            <button
              type="button"
              mat-icon-button
              matSuffix
              (click)="$event.stopPropagation(); clearPromoCode(true)"
              *ngIf="promoCode"
            >
              <mat-icon class="color-secondary">cancel</mat-icon>
            </button>

            <button
              type="button"
              mat-icon-button
              matSuffix
              *ngIf="(promo && promoCode) || promoGamification"
            >
              <mat-icon class="color-green">check_circle</mat-icon>
            </button>
          </div>
          <button
            type="button"
            mat-flat-button
            matSuffix
            (click)="$event.stopPropagation(); applyPromoCode()"
            *ngIf="!promo || !promoCode"
          >
            {{ "common.apply" | translate }}
          </button>
          <button
            type="button"
            mat-flat-button
            matSuffix
            (click)="$event.stopPropagation(); applyPromoCode()"
            *ngIf="promo && promoCode"
          >
            {{ "common.applied" | translate }}
          </button>
        </mat-form-field>
      </div>
      <div class="promo-error" *ngIf="promoError">
        {{
          "common." + promoError
            | translate
              : {
                  promoMinAmt: promoMinAmount | number : "1.2-2",
                  promoMaxAmt: promoMaxAmount | number : "1.2-2"
                }
        }}
      </div>
      <div
        class="promo-valid"
        *ngIf="((promo && promoCode) || promoGamification) && !promoError"
      >
        Promo code applied.
      </div>
    </div>
    <ng-container>
      <app-order-summary-note
        [text]="
          'comparison.orderSummaryNoteDisclaimerWithoutServiceFee' | translate
        "
      ></app-order-summary-note>
    </ng-container>
    <!-- <ng-container [ngSwitch]="selectedQuotation?.code">
      <ng-container *ngSwitchDefault>
        <ng-container *ngIf="isInsurerWithoutServiceFee">
          <app-order-summary-note
            [text]="
              'comparison.orderSummaryNoteDisclaimerWithoutServiceFee'
                | translate
            "
          ></app-order-summary-note>
        </ng-container>
        <ng-container *ngIf="!isInsurerWithoutServiceFee">
          <app-order-summary-note
            [text]="'comparison.orderSummaryNoteDisclaimer' | translate"
          ></app-order-summary-note>
        </ng-container>
      </ng-container>
    </ng-container> -->
  </ng-container>
</ng-template>

<ng-template #paymentOption>
  <div class="pt-xs" (click)="$event.stopPropagation()" #paymentAutoScroll>
    <app-section-title
      title="plans.step3Content.paymentOption"
    ></app-section-title>

    <div class="pending-payment-alert" *ngIf="isRetryPayment">
      <mat-icon class="alert-icon">error_outline</mat-icon>

      <div class="alert-content">
        <span class="alert-title"
          >{{ "response.pendingPayment" | translate }}:</span
        >
        <span class="alert-text">
          {{ "response.pendingPaymentDesc" | translate }}
        </span>
      </div>
    </div>
  </div>

  <app-payment-options
    *ngIf="stepper?.selectedIndex == 3"
    [totalPrice]="getFinalTotal()"
    [totalPriceBeforeCharges]="getFinalTotalBeforeCharges()"
    [bankCharge]="bankInstallmentCharge"
    [paymentFormGroup]="paymentFormGroup"
    [eppChargeList]="eppChargeList"
    [previousTriedPayment]="dataRetryPayment?.policy?.paymentProvider"
  ></app-payment-options>
</ng-template>

<ng-template #multiCheckbox let-form="form">
  <div class="multi-checkbox-section" [formGroup]="form">
    <!--------------------------------------------------------------------------->
    <!-- Implement new Acknowledge Popup, currently leave it for reference purpose -->
    <!--------------------------------------------------------------------------->

    <!-- <div
      class="multi-checkbox-section__bg"
      *ngIf="selectedQuotation?.name !== 'Generali'"
    >
      <section className="allow-pointer">
        <mat-checkbox
          formControlName="agreeInfo"
          (click)="$event.stopPropagation()"
          >{{ "common.confirmationOne" | translate }}
        </mat-checkbox>
      </section>

      <section
        className="allow-pointer"
      >
        <mat-checkbox
          formControlName="aqadTC"
          (click)="$event.stopPropagation()"
          >{{ "common.confirmationAqad" | translate }}
          <a
            [href]="
              'https://storage.googleapis.com/dev-ps-asset/motor/policy_docs/Aqad.pdf'
            "
            target="blank"
            ><b>Aqad</b>.</a
          >
        </mat-checkbox>
      </section>

      <section formArrayName="doc" className="allow-pointer">
        <ng-container
          *ngFor="let item of getAgreeFormArray()?.controls; let i = index"
        >
          <ng-container [formGroupName]="i">
            <mat-checkbox
              formControlName="checked"
              (click)="$event.stopPropagation()"
            >
              {{ "common.confirmationTwo" | translate }}
              <a
                [href]="getAgreeFormArray()?.controls[i].value?.url"
                target="blank"
              >
                {{ getAgreeFormArray()?.controls[i].value?.name }}
              </a>
              <b> {{ "InsurerName." + selectedQuotation?.name | translate }}</b
              >.
            </mat-checkbox>
          </ng-container>
        </ng-container>
      </section>

      <section *ngIf="isAllianzQuotation" className="allow-pointer">
        <mat-checkbox formControlName="marketingConsent" (click)="$event.stopPropagation()">
          {{ "common.allianzMarketingConsent" | translate}}
        </mat-checkbox>
      </section>
    </div> -->

    <button
      *ngIf="!isRetryPayment && !(screenSizeService.isMobile$ | async)"
      mat-flat-button
      [disabled]="paymentFormGroup?.invalid"
      (click)="showAcknowledgementDialog()"
    >
      {{ "common.reviewAndAgree" | translate }}
    </button>
    <button
      *ngIf="isRetryPayment && !(screenSizeService.isMobile$ | async)"
      mat-flat-button
      [disabled]="paymentFormGroup?.invalid"
      (click)="showAcknowledgementDialog()"
    >
      {{ "common.retryPayment" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #psMobilevoucherHeader>
  <div *ngIf="screenSizeService.isMobile$ | async">
    <div class="voucher-dropdown">
      <div class="voucher_container">
        <div class="voucher_block" (click)="toggleVoucher()">
          <div>
            <mat-icon>local_activity</mat-icon>
          </div>
          <div>{{ "voucher.applyVoucher" | translate }}</div>
          <button type="button" mat-icon-button matSuffix>
            <mat-icon class="color-secondary">chevron_right</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #psMobileDiscountTemplate>
  <div
    *ngIf="
      (screenSizeService.isMobile$ | async) &&
      (getTotalDiscount() || referralCode)
    "
  >
    <div class="discountTemplate">
      <div>
        <span *ngIf="numberOfVoucher"
          >{{ numberOfVoucher }}
          {{ "voucher.voucherDiscountApplied" | translate }}</span
        >
        <span *ngIf="referralCode">{{
          "voucher.referralCodeApplied" | translate
        }}</span>
      </div>
      <div>
        <span class="discountPrice" style="font-size: 12px">
          -RM{{ getTotalDiscount() | number : "1.2-2" }}</span
        >
      </div>
    </div>
  </div>
</ng-template>

<ng-template #psMobileNextBtn>
  <div *ngIf="screenSizeService.isMobile$ | async">
    <!-- Campaign Banner with Timer Mobile -->
    <!-- Remove Campaign Banner For Mobile - Requested by Prakash -->
    <!-- <div class="campaign-banner-mobile" *ngIf="cdTimerShow">
      <div class="ribbon-container-mobile">
        <img class="ribbon-img-mobile" src="/assets/image/star-redribbon.svg" />
        <div class="save-badge-mobile">
          <img class="badge-img-mobile" src="/assets/image/campaignBadge.gif" />
        </div>
      </div>
      <div class="campaign-content-mobile">
        <div class="campaign-text">
          <div>
            <span class="header-mobile">{{
              "common.EnjoyTenOffHeader" | translate
            }}</span>
          </div>

          <div>
            <span class="body-mobile"
              >RM
              {{
                getTotalBasePremiumDiscountUpcomingCampaignAmt()
                  | number : "1.2-2"
              }}
              OFF</span
            >
          </div>

          <div class="campaign-timer-box-mobile">
            {{ cdTimerStartEndLabel | translate }}
            <span class="campaign-timer-mobile">{{
              cdTimerHours | number : "2.0"
            }}</span>
            :
            <span class="campaign-timer-mobile">{{
              cdTimerMinutes | number : "2.0"
            }}</span>
            :
            <span class="campaign-timer-mobile">{{
              cdTimerSeconds | number : "2.0"
            }}</span>
          </div>
        </div>
      </div>
    </div> -->

    <div class="btn-content">
      <div class="btn-content__total-txt">
        {{ "common.totalAmount" | translate }}
      </div>
      <div class="btn-content__price">
        <div class="btn-content__price__txt">
          RM {{ getFinalTotal() | number : "1.2-2" }}
        </div>
        <div
          class="btn-content__price__desc"
          [innerHTML]="getPaymentDurationLabel()"
        ></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #inCollabText>
  <div class="collab-text">
    <div class="incollab-text">
      {{ "plans.inCollab" | translate }}
    </div>
    <img [src]="inCollabImageSrc" alt="logo" class="main-logo" />
    <!-- <img
      src="https://i.ibb.co/j32pWbR/Pacific-Insurance-Logo.png"
      alt="logo"
      class="main-logo"
      *ngIf="!excessData?.length"
    /> -->
    <img
      src="https://storage.googleapis.com/dev-ps-asset/Car_Insurance/pando-logo.png"
      alt="logo"
      class="main-logo"
      *ngIf="excessData?.length"
    />
  </div>
</ng-template>

<ng-template #referralTemplate>
  <div class="promo-input pt-sm" (click)="$event.stopPropagation()">
    <div class="flex">
      <mat-form-field appearance="outline">
        <input
          matInput
          [placeholder]="'common.enterReferralCode' | translate"
          [(ngModel)]="referralCode"
          autocomplete="off"
          (click)="$event.stopPropagation()"
          [ngModelOptions]="{ standalone: true }"
        />

        <div class="floating-btn">
          <button
            type="button"
            mat-icon-button
            matSuffix
            (click)="$event.stopPropagation(); clearReferralCode()"
            *ngIf="referralCode"
          >
            <mat-icon class="color-secondary">cancel</mat-icon>
          </button>

          <button
            type="button"
            mat-icon-button
            matSuffix
            *ngIf="referral && referralCode"
          >
            <mat-icon class="color-green">check_circle</mat-icon>
          </button>
        </div>

        <button
          type="button"
          mat-flat-button
          matSuffix
          (click)="$event.stopPropagation(); applyReferralCode()"
          *ngIf="!referral || !referralCode"
        >
          {{ "common.apply" | translate }}
        </button>

        <button
          type="button"
          mat-flat-button
          matSuffix
          (click)="$event.stopPropagation(); applyReferralCode()"
          *ngIf="referral && referralCode"
        >
          {{ "common.applied" | translate }}
        </button>
      </mat-form-field>
    </div>

    <div class="promo-error" *ngIf="referralError">
      {{ "common." + referralError | translate }}
    </div>

    <div class="promo-valid" *ngIf="referral && referralCode && !referralError">
      {{ "common.referralCodeApplied" | translate }}
    </div>
  </div>
</ng-template>

<ng-template #drivePlusTemplate>
  <ng-container *ngIf="selectedMotorMembership.length">
    <div class="drivePlus__card__btn">
      <!-- Lite -->
      <button
        mat-stroked-button
        color="primary"
        class="driveplus-btn"
        [ngClass]="{
          selected: hasSelectedMotorMembershipCode(drivePlusLiteAddon?.code)
        }"
        *ngIf="drivePlusLiteAddon"
        (click)="toggleMotorMembership($event, drivePlusLiteAddon, true)"
      >
        Lite
      </button>

      <!-- Standard -->
      <button
        mat-stroked-button
        color="primary"
        class="driveplus-btn"
        *ngIf="drivePlusStandardAddon"
        [ngClass]="{
          selected: hasSelectedMotorMembershipCode(drivePlusStandardAddon.code)
        }"
        (click)="toggleMotorMembership($event, drivePlusStandardAddon, true)"
      >
        Standard
      </button>

      <!-- Premium -->
      <button
        mat-stroked-button
        color="primary"
        class="driveplus-btn"
        [ngClass]="{
          selected: hasSelectedMotorMembershipCode(drivePlusPremiumAddon.code)
        }"
        *ngIf="drivePlusPremiumAddon"
        (click)="toggleMotorMembership($event, drivePlusPremiumAddon, true)"
      >
        Premium
      </button>
    </div>

    <div class="drivePlus__card__special">
      <span class="small">RM</span>
      {{ selectedMotorMembership[0]?.evaluate }}
      {{ motorMembershipPromoPriceTag | translate }}
    </div>

    <div>
      {{ "plans.motorMembership.NP" | translate }}: RM{{
        selectedMotorMembership[0]?.oriEvaluate
      }}
    </div>
  </ng-container>
</ng-template>

<!-- ## End Template: all the templates ends here -->
